
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("9feT0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("3voN7")).NotificationLogs);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $3voN7 = parcelRequire("3voN7");

});
parcelRegister("3voN7", function(module, exports) {

$parcel$export(module.exports, "NotificationLogs", () => $ef130062a8e57433$export$1139895a5af7252e);

var $5uXOq = parcelRequire("5uXOq");

var $jEoQl = parcelRequire("jEoQl");
const $ef130062a8e57433$export$1139895a5af7252e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jEoQl.NotificationLogsPage), null);

});
parcelRegister("jEoQl", function(module, exports) {

$parcel$export(module.exports, "NotificationLogsPage", () => $1b0c57a6ac72964e$export$f3b513321a19158f);

var $lLa2t = parcelRequire("lLa2t");

var $fX3nG = parcelRequire("fX3nG");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9suPc = parcelRequire("9suPc");

var $8Uumt = parcelRequire("8Uumt");

var $fuUnn = parcelRequire("fuUnn");
var $jbeEq = parcelRequire("jbeEq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $cS37j = parcelRequire("cS37j");

var $39xOx = parcelRequire("39xOx");

var $jcw0u = parcelRequire("jcw0u");

var $co1wz = parcelRequire("co1wz");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $dAfqg = parcelRequire("dAfqg");

var $8pMQX = parcelRequire("8pMQX");

var $koeKL = parcelRequire("koeKL");

var $bfjnH = parcelRequire("bfjnH");

var $cdbNa = parcelRequire("cdbNa");

var $gqagC = parcelRequire("gqagC");

var $9ePAM = parcelRequire("9ePAM");

var $ePYuj = parcelRequire("ePYuj");

var $kH3pk = parcelRequire("kH3pk");
const $1b0c57a6ac72964e$var$GetNotificationLogsBreadcrumbs = (projectContext, breadcrumbRoot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1b0c57a6ac72964e$var$breadcrumbContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbeEq.default), {
        onExpand: ()=>{}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
        text: breadcrumbRoot,
        href: "/jira/projects"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
        text: `${projectContext?.projectName}`,
        href: `/browse/${projectContext?.projectKey}`
    })));
const $1b0c57a6ac72964e$export$23ce48b53d627a0 = (0, $fX3nG.default);
const $1b0c57a6ac72964e$var$PAZE_SIZE = 30;
const $1b0c57a6ac72964e$var$NO_ERROR = 'No Error';
const $1b0c57a6ac72964e$export$1139895a5af7252e = ({ projectContext: projectContext })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const outgoingMailConfigData = (0, $bfjnH.useOutgoingMailConfig)();
    const { outgoingMailConfig: outgoingMailConfig, error: error, loading: loading } = outgoingMailConfigData;
    if (error) (0, $jcw0u.default)({
        meta: {
            id: 'ErrorFetchingOutgoingMailConfigData',
            packageName: 'jiraSpaAppsServicedeskNotificationLogs',
            teamName: 'spartans'
        },
        error: new Error(error),
        sendToPrivacyUnsafeSplunk: true
    });
    const cloudId = (0, $koeKL.useCloudId)();
    const projectId = projectContext?.projectId;
    const projectKey = projectContext?.projectKey;
    const breadcrumbRoot = formatMessage((0, $9ePAM.messages).projects);
    const breadcrumbs = $1b0c57a6ac72964e$var$GetNotificationLogsBreadcrumbs(projectContext, breadcrumbRoot);
    const LOGS_QUERY = $1b0c57a6ac72964e$export$23ce48b53d627a0;
    const notificationActionType = 'CUSTOMER_INVITE';
    const notificationType = null;
    const variables = {
        cloudId: cloudId,
        projectId: projectId,
        notificationActionType: notificationActionType,
        notificationType: notificationType
    };
    const graphQLNode = (0, $lLa2t.default);
    const emailData = (0, $8Uumt.useLazyLoadQuery)(LOGS_QUERY, variables);
    const { data: data, loadNext: loadNext } = (0, $8Uumt.usePaginationFragment)(graphQLNode, emailData);
    const responseType = data.aquaOutgoingEmailLogs?.GetNotificationLogs?.__typename;
    if (responseType === 'QueryError') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errorMessage = data.aquaOutgoingEmailLogs?.GetNotificationLogs?.message;
        const queryError = new Error(errorMessage);
        (0, $jcw0u.default)({
            meta: {
                id: 'LogsQueryReturnedError',
                packageName: 'jiraSpaAppsServicedeskNotificationLogs',
                teamName: 'spartans'
            },
            error: queryError,
            sendToPrivacyUnsafeSplunk: true
        });
        throw queryError;
    }
    const hasMoreData = data.aquaOutgoingEmailLogs?.GetNotificationLogs?.logs?.pageInfo.hasNextPage;
    const allRows = data;
    const allRowEdges = allRows.aquaOutgoingEmailLogs?.GetNotificationLogs?.logs?.edges;
    const hasError = allRows.aquaOutgoingEmailLogs?.GetNotificationLogs?.identifier ? allRows.aquaOutgoingEmailLogs?.GetNotificationLogs.message : $1b0c57a6ac72964e$var$NO_ERROR;
    const parentRef = (0, $5uXOq.useRef)(null);
    const getRowHeight = (0, $5uXOq.useCallback)(()=>60, []);
    const allRowsLength = allRowEdges ? allRowEdges.length : 0;
    const virtualizer = (0, $9suPc.useVirtualizer)({
        count: hasMoreData ? allRowsLength + 1 : allRowsLength,
        getScrollElement: ()=>parentRef.current,
        estimateSize: getRowHeight,
        overscan: 5
    });
    (0, $5uXOq.useEffect)(()=>{
        // save calling `getVirtualItems()` unnecessarily
        if (!allRowEdges || !hasMoreData) return;
        const lastItem = virtualizer.getVirtualItems().at(-1);
        if (lastItem && lastItem.index >= allRowEdges.length - 1) loadNext($1b0c57a6ac72964e$var$PAZE_SIZE);
         // Do not change the dependency to just be `virtualizer` or `virtualizer.getVirtualItems`
    // it must call the function for dependencies to be calculated correctly (and therefore render at all).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasMoreData,
        loadNext,
        virtualizer.getVirtualItems(),
        allRowEdges
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "CustomerNotificationLogs",
        packageName: "jiraSpaAppsServicedeskNotificationLogs",
        teamName: "spartans"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "customerNotificationLogs",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1b0c57a6ac72964e$var$notificationAppStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        breadcrumbs: breadcrumbs
    }, formatMessage((0, $9ePAM.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePYuj.NotificationAppSubHeader), null), outgoingMailConfig !== null && !error && !loading && !outgoingMailConfig?.enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        eventName: "LogsTable OutGoingMailDisabledText"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cdbNa.EnableOutgoingMailInfo), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1b0c57a6ac72964e$var$LogsTableWrapper, {
        ref: parentRef
    }, hasError === $1b0c57a6ac72964e$var$NO_ERROR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        eventName: "LogsTable Render"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gqagC.LogsTable), {
        virtualizer: virtualizer,
        allEdges: allRowEdges || [],
        projectKey: projectKey,
        outgoingMailConfigData: outgoingMailConfigData
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)));
};
const $1b0c57a6ac72964e$export$f3b513321a19158f = ()=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    if (!projectContext) {
        (0, $jcw0u.default)({
            meta: {
                id: 'ProjectContextNULL',
                packageName: 'jiraSpaAppsServicedeskNotificationLogs',
                teamName: 'spartans'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return null;
    }
    const isProjectAdmin = Boolean(projectContext?.isProjectAdmin);
    if (!isProjectAdmin) {
        (0, $jcw0u.default)({
            meta: {
                id: 'UserIsNotProjectAdmin',
                packageName: 'jiraSpaAppsServicedeskNotificationLogs',
                teamName: 'spartans'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.project-not-found"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.ProjectNotFound), null));
    }
    if ((0, $co1wz.ff)('sptn-1793-cn-logs-for-request-notifications_a9umh')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kH3pk.NotificationLogsTabLayout), {
        projectContext: projectContext
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1b0c57a6ac72964e$export$1139895a5af7252e, {
        projectContext: projectContext
    });
};
const $1b0c57a6ac72964e$var$breadcrumbContainerStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.negative.050'
});
const $1b0c57a6ac72964e$var$notificationAppStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.500',
    marginRight: 'space.500'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b0c57a6ac72964e$var$LogsTableWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3in9zg _1bsb1osq _1reo1wug _18m91wug _19pkpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lLa2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9aa4d923f2497f4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<af72f58ff1d84a2e034461609384cf3c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $6hrwv = parcelRequire("6hrwv");
const $f9aa4d923f2497f4$var$node = function() {
    var v0 = [
        "aquaOutgoingEmailLogs",
        "GetNotificationLogs",
        "logs"
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": 20,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "kind": "RootArgument",
                "name": "notificationActionType"
            },
            {
                "kind": "RootArgument",
                "name": "notificationType"
            },
            {
                "kind": "RootArgument",
                "name": "projectId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "count",
                        "cursor": "cursor"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $6hrwv.default)
            }
        },
        "name": "notificationLogsPage_spaAppsServicedeskNotificationLogs_NotificationLogsWithFilters",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "concreteType": "AquaOutgoingEmailLogsQueryApi",
                "kind": "LinkedField",
                "name": "aquaOutgoingEmailLogs",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "notificationActionType",
                                "variableName": "notificationActionType"
                            },
                            {
                                "kind": "Variable",
                                "name": "notificationType",
                                "variableName": "notificationType"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectId",
                                "variableName": "projectId"
                            }
                        ],
                        "kind": "LinkedField",
                        "name": "GetNotificationLogs",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "alias": "logs",
                                        "concreteType": "AquaOutgoingEmailLogConnection",
                                        "kind": "LinkedField",
                                        "name": "__aquaOutgoingEmail__logs_connection",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "AquaOutgoingEmailLogItemEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "logsTable_logEdges"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "cursor"
                                                    },
                                                    {
                                                        "concreteType": "AquaOutgoingEmailLogItem",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v1 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "startCursor"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "endCursor"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasNextPage"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasPreviousPage"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "type": "AquaOutgoingEmailLog"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "identifier"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "message"
                                    }
                                ],
                                "type": "QueryError"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$f9aa4d923f2497f4$var$node.hash = "a9f924c846b4519d1d6e57e3fa6a7ecd";
var $f9aa4d923f2497f4$export$2e2bcd8739ae039 = $f9aa4d923f2497f4$var$node;

});
parcelRegister("6hrwv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c12b2de194b0001$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7448d4ded26e7d82e81280c5f8e84be5>>
 * @relayHash 5fb26d96af926503876690163bb4fe4e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3cc82469233238c8b3202d4ede6a670f37ef6bc9d81c8519cdec803617d0ede0
const $3c12b2de194b0001$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": 20,
            "kind": "LocalArgument",
            "name": "count"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cursor"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "notificationActionType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "notificationType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "aquaOutgoingEmailLogsQueryWithFilters",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        },
                        {
                            "kind": "Variable",
                            "name": "cursor",
                            "variableName": "cursor"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "notificationLogsPage_spaAppsServicedeskNotificationLogs_NotificationLogsWithFilters"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "aquaOutgoingEmailLogsQueryWithFilters",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "AquaOutgoingEmailLogsQueryApi",
                    "kind": "LinkedField",
                    "name": "aquaOutgoingEmailLogs",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "notificationActionType",
                                    "variableName": "notificationActionType"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "notificationType",
                                    "variableName": "notificationType"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectId",
                                    "variableName": "projectId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "GetNotificationLogs",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v2 /*: any*/ ,
                                            "concreteType": "AquaOutgoingEmailLogConnection",
                                            "kind": "LinkedField",
                                            "name": "logs",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AquaOutgoingEmailLogItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AquaOutgoingEmailLogItem",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "notificationActionType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "actionTimestamp"
                                                                },
                                                                {
                                                                    "concreteType": "AquaNotificationDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "notificationDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "errorKey"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mailboxMessage"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "recipient",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "email"
                                                                                }
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "name"
                                                                                }
                                                                            ],
                                                                            "type": "CustomerUser"
                                                                        },
                                                                        v3 /*: any*/ 
                                                                    ]
                                                                },
                                                                v1 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "startCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasPreviousPage"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v2 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "aquaOutgoingEmail__logs",
                                            "kind": "LinkedHandle",
                                            "name": "logs"
                                        }
                                    ],
                                    "type": "AquaOutgoingEmailLog"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3cc82469233238c8b3202d4ede6a670f37ef6bc9d81c8519cdec803617d0ede0",
            "metadata": {},
            "name": "aquaOutgoingEmailLogsQueryWithFilters",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3c12b2de194b0001$var$node.hash = "a9f924c846b4519d1d6e57e3fa6a7ecd";
var $3c12b2de194b0001$export$2e2bcd8739ae039 = $3c12b2de194b0001$var$node;

});


parcelRegister("fX3nG", function(module, exports) {

$parcel$export(module.exports, "default", () => $063beb705799b7d1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f2f5ea60618e877ff5a2993b524f9bee>>
 * @relayHash 09692307ef9d5449b9314731266a9a48
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a5025a7606e1b419cfaa2240d0c09cec5ee59a77b2ce5721394d5cfcc054563a
const $063beb705799b7d1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "notificationActionType"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "notificationType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "notificationLogsPageWithFiltersQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "notificationLogsPage_spaAppsServicedeskNotificationLogs_NotificationLogsWithFilters"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "notificationLogsPageWithFiltersQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "AquaOutgoingEmailLogsQueryApi",
                    "kind": "LinkedField",
                    "name": "aquaOutgoingEmailLogs",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "notificationActionType",
                                    "variableName": "notificationActionType"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "notificationType",
                                    "variableName": "notificationType"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectId",
                                    "variableName": "projectId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "GetNotificationLogs",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v5 /*: any*/ ,
                                            "concreteType": "AquaOutgoingEmailLogConnection",
                                            "kind": "LinkedField",
                                            "name": "logs",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AquaOutgoingEmailLogItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AquaOutgoingEmailLogItem",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "notificationActionType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "actionTimestamp"
                                                                },
                                                                {
                                                                    "concreteType": "AquaNotificationDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "notificationDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "errorKey"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mailboxMessage"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "recipient",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "email"
                                                                                }
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "name"
                                                                                }
                                                                            ],
                                                                            "type": "CustomerUser"
                                                                        },
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "startCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasPreviousPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "logs(first:20)"
                                        },
                                        {
                                            "args": v5 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "aquaOutgoingEmail__logs",
                                            "kind": "LinkedHandle",
                                            "name": "logs"
                                        }
                                    ],
                                    "type": "AquaOutgoingEmailLog"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a5025a7606e1b419cfaa2240d0c09cec5ee59a77b2ce5721394d5cfcc054563a",
            "metadata": {},
            "name": "notificationLogsPageWithFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$063beb705799b7d1$var$node.hash = "c77cb7f044c5201afd97b3bb7a707bd0";
var $063beb705799b7d1$export$2e2bcd8739ae039 = $063beb705799b7d1$var$node;

});

parcelRegister("9suPc", function(module, exports) {
$parcel$export(module.exports, "elementScroll", () => (parcelRequire("lASGB")).elementScroll);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("cDbvq")).notUndefined);
$parcel$export(module.exports, "observeElementOffset", () => (parcelRequire("lASGB")).observeElementOffset);
$parcel$export(module.exports, "observeElementRect", () => (parcelRequire("lASGB")).observeElementRect);
$parcel$export(module.exports, "observeWindowOffset", () => (parcelRequire("lASGB")).observeWindowOffset);
$parcel$export(module.exports, "observeWindowRect", () => (parcelRequire("lASGB")).observeWindowRect);
$parcel$export(module.exports, "Virtualizer", () => (parcelRequire("lASGB")).Virtualizer);
$parcel$export(module.exports, "windowScroll", () => (parcelRequire("lASGB")).windowScroll);

$parcel$export(module.exports, "useVirtualizer", () => $6e2ea3c4609c52d6$export$dd6d526d88b5a137);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $lASGB = parcelRequire("lASGB");
const $6e2ea3c4609c52d6$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
function $6e2ea3c4609c52d6$var$useVirtualizerBase(options) {
    const rerender = $5uXOq.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $7nsd3.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $5uXOq.useState(()=>new (0, $lASGB.Virtualizer)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $5uXOq.useEffect(()=>{
        return instance._didMount();
    }, []);
    $6e2ea3c4609c52d6$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $6e2ea3c4609c52d6$export$dd6d526d88b5a137(options) {
    return $6e2ea3c4609c52d6$var$useVirtualizerBase({
        observeElementRect: $lASGB.observeElementRect,
        observeElementOffset: $lASGB.observeElementOffset,
        scrollToFn: (0, $lASGB.elementScroll),
        ...options
    });
}
function $6e2ea3c4609c52d6$export$645722dcac657cb9(options) {
    return $6e2ea3c4609c52d6$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $lASGB.observeWindowRect),
        observeElementOffset: (0, $lASGB.observeWindowOffset),
        scrollToFn: (0, $lASGB.windowScroll),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}

});
parcelRegister("lASGB", function(module, exports) {

$parcel$export(module.exports, "observeElementRect", () => $fb876145852c2505$export$5a50ff2cde8c3802);
$parcel$export(module.exports, "observeWindowRect", () => $fb876145852c2505$export$e911b82c7a99311);
$parcel$export(module.exports, "observeElementOffset", () => $fb876145852c2505$export$fbc040aee017375a);
$parcel$export(module.exports, "observeWindowOffset", () => $fb876145852c2505$export$518998f8c5d09287);
$parcel$export(module.exports, "windowScroll", () => $fb876145852c2505$export$2162c5b3eeedd27);
$parcel$export(module.exports, "elementScroll", () => $fb876145852c2505$export$1cdb988e5ab69fe7);
$parcel$export(module.exports, "Virtualizer", () => $fb876145852c2505$export$89be5a243e59c4b2);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("cDbvq")).notUndefined);

var $cDbvq = parcelRequire("cDbvq");
const $fb876145852c2505$export$76974b428a49f15b = (index)=>index;
const $fb876145852c2505$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $fb876145852c2505$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (!targetWindow.ResizeObserver) return ()=>{};
    const observer = new targetWindow.ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $fb876145852c2505$var$addEventListenerOptions = {
    passive: true
};
const $fb876145852c2505$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $fb876145852c2505$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $fb876145852c2505$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $fb876145852c2505$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $fb876145852c2505$var$supportsScrollend ? ()=>void 0 : (0, $cDbvq.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            const { horizontal: horizontal, isRtl: isRtl } = instance.options;
            offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $fb876145852c2505$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $fb876145852c2505$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $fb876145852c2505$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $fb876145852c2505$var$supportsScrollend ? ()=>void 0 : (0, $cDbvq.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $fb876145852c2505$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $fb876145852c2505$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $fb876145852c2505$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $fb876145852c2505$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $fb876145852c2505$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $fb876145852c2505$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.targetWindow = null;
        this.isScrolling = false;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollRect = null;
        this.scrollOffset = null;
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.elementsCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        this._measureElement(entry.target, entry);
                    });
                });
            };
            return {
                disconnect: ()=>{
                    var _a;
                    (_a = get()) == null || _a.disconnect();
                    _ro = null;
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $fb876145852c2505$export$76974b428a49f15b,
                rangeExtractor: $fb876145852c2505$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $fb876145852c2505$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                isScrollingResetDelay: 150,
                enabled: true,
                isRtl: false,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $cDbvq.memo)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.observer.disconnect();
            this.scrollElement = null;
            this.targetWindow = null;
        };
        this._didMount = ()=>{
            return ()=>{
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            var _a;
            const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                if (!scrollElement) {
                    this.maybeNotify();
                    return;
                }
                this.scrollElement = scrollElement;
                if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                this.elementsCache.forEach((cached)=>{
                    this.observer.observe(cached);
                });
                this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    this.isScrolling = isScrolling;
                    this.maybeNotify();
                }));
            }
        };
        this.getSize = ()=>{
            if (!this.options.enabled) {
                this.scrollRect = null;
                return 0;
            }
            this.scrollRect = this.scrollRect ?? this.options.initialRect;
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getScrollOffset = ()=>{
            if (!this.options.enabled) {
                this.scrollOffset = null;
                return 0;
            }
            this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
            return this.scrollOffset;
        };
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurementOptions = (0, $cDbvq.memo)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey,
                this.options.enabled
            ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey,
                enabled: enabled
            };
        }, {
            key: false
        });
        this.getMeasurements = (0, $cDbvq.memo)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
            if (!enabled) {
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                return [];
            }
            if (this.measurementsCache.length === 0) {
                this.measurementsCache = this.options.initialMeasurementsCache;
                this.measurementsCache.forEach((item)=>{
                    this.itemSizeCache.set(item.key, item.size);
                });
            }
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $cDbvq.memo)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.getScrollOffset()
            ], (measurements, outerSize, scrollOffset)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $fb876145852c2505$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getIndexes = (0, $cDbvq.memo)(()=>[
                this.options.rangeExtractor,
                this.calculateRange(),
                this.options.overscan,
                this.options.count
            ], (rangeExtractor, range, overscan, count)=>{
            return range === null ? [] : rangeExtractor({
                startIndex: range.startIndex,
                endIndex: range.endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const index = this.indexFromElement(node);
            const item = this.measurementsCache[index];
            if (!item) return;
            const key = item.key;
            const prevNode = this.elementsCache.get(key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.elementsCache.set(key, node);
            }
            if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
        };
        this.resizeItem = (index, size)=>{
            const item = this.measurementsCache[index];
            if (!item) return;
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) {
                this.elementsCache.forEach((cached, key)=>{
                    if (!cached.isConnected) {
                        this.observer.unobserve(cached);
                        this.elementsCache.delete(key);
                    }
                });
                return;
            }
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $cDbvq.memo)(()=>[
                this.getIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            if (measurements.length === 0) return void 0;
            return (0, $cDbvq.notUndefined)(measurements[$fb876145852c2505$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $cDbvq.notUndefined)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align)=>{
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (toOffset <= scrollOffset) align = "start";
                else if (toOffset >= scrollOffset + size) align = "end";
                else align = "start";
            }
            if (align === "start") toOffset;
            else if (align === "end") toOffset = toOffset - size;
            else if (align === "center") toOffset = toOffset - size / 2;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - size;
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const item = this.measurementsCache[index];
            if (!item) return void 0;
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align),
                align
            ];
        };
        this.isDynamicMode = ()=>this.elementsCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
                this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
            if (!offsetAndAlign) return;
            const [offset, align] = offsetAndAlign;
            this._scrollToOffset(offset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.elementsCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [latestOffset] = (0, $cDbvq.notUndefined)(this.getOffsetForIndex(index, align));
                    if (!(0, $cDbvq.approxEqual)(latestOffset, this.getScrollOffset())) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getScrollOffset() + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
            return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
    }
}
const $fb876145852c2505$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $fb876145852c2505$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
    const count = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    const startIndex = $fb876145852c2505$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
    let endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}

});
parcelRegister("cDbvq", function(module, exports) {

$parcel$export(module.exports, "memo", () => $93220d646a94e11c$export$7c73462e0d25e514);
$parcel$export(module.exports, "notUndefined", () => $93220d646a94e11c$export$9a1adf421b69c6a);
$parcel$export(module.exports, "approxEqual", () => $93220d646a94e11c$export$8a4f1dcc58a69dbd);
$parcel$export(module.exports, "debounce", () => $93220d646a94e11c$export$61fc7d43ac8f84b0);
function $93220d646a94e11c$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    return ()=>{
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    };
}
function $93220d646a94e11c$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $93220d646a94e11c$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
const $93220d646a94e11c$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
    let timeoutId;
    return function(...args) {
        targetWindow.clearTimeout(timeoutId);
        timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
    };
};

});



parcelRegister("cS37j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a15efb09f101ecb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $57MwZ = parcelRequire("57MwZ");
const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57MwZ.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
    });
var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a15efb09f101ecb$var$ActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("57MwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9694e728fd1ea060$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $5uXOq = parcelRequire("5uXOq");

var $eeGIy = parcelRequire("eeGIy");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eeGIy.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eeGIy.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eeGIy.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eeGIy.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eeGIy.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eeGIy.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;

});
parcelRegister("eeGIy", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $0c196d37a4e8266c$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $0c196d37a4e8266c$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $0c196d37a4e8266c$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $0c196d37a4e8266c$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $0c196d37a4e8266c$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $0c196d37a4e8266c$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
function $0c196d37a4e8266c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0c196d37a4e8266c$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $0c196d37a4e8266c$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $0c196d37a4e8266c$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $0c196d37a4e8266c$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $0c196d37a4e8266c$var$titleContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $0c196d37a4e8266c$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $0c196d37a4e8266c$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $0c196d37a4e8266c$var$bottomBarStyles = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.200'
});
const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $0c196d37a4e8266c$var$outerStyles
    }, children);
};
const $0c196d37a4e8266c$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("h1", {
        css: [
            $0c196d37a4e8266c$var$titleStyles,
            truncateTitle && $0c196d37a4e8266c$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $0c196d37a4e8266c$var$titleWrapperStyles,
            truncateTitle && $0c196d37a4e8266c$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $0c196d37a4e8266c$var$titleContainerStyles,
            truncateTitle && $0c196d37a4e8266c$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $0c196d37a4e8266c$var$actionStyles
    }, children);
};
const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        xcss: $0c196d37a4e8266c$var$bottomBarStyles
    }, children);
};

});



// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("8pMQX", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $951f6bd200bf8b89$export$849d319c342682a2);
$parcel$export(module.exports, "GenericError", () => $951f6bd200bf8b89$export$7d465be8efa67280);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $ew1Lk = parcelRequire("ew1Lk");

var $bTyOW = parcelRequire("bTyOW");

var $fC09Q = parcelRequire("fC09Q");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $dIdda = parcelRequire("dIdda");

var $4AdE6 = parcelRequire("4AdE6");
const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew1Lk.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).notFoundTitle),
        description: formatMessage((0, $4AdE6.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
            to: projectsPath
        }, formatMessage((0, $4AdE6.default).notFoundAction))
    }));
};
const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew1Lk.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $bTyOW.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).genericErrorTitle),
        description: formatMessage((0, $4AdE6.default).genericErrorDescription)
    }));
};

});
parcelRegister("ew1Lk", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $41b549fa18234081$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $6nkVm = parcelRequire("6nkVm");

class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $6nkVm.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6nkVm.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("bTyOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5073396748f92b4e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $5073396748f92b4e$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5I4tL")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("h8kvT")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $dCLgq = parcelRequire("dCLgq");

var $h8kvT = parcelRequire("h8kvT");

var $5I4tL = parcelRequire("5I4tL");
const $5073396748f92b4e$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5I4tL)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($h8kvT))
});
var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
// for advanced use only
const $5073396748f92b4e$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("h8kvT", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("5I4tL", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("fC09Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb376757c4acc5ab$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $dCLgq = parcelRequire("dCLgq");

var $3pGSh = parcelRequire("3pGSh");
const $bb376757c4acc5ab$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3pGSh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3pGSh))
});
var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
// for advanced use only
const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("3pGSh", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("4AdE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $135a9e70a6f11b3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    }
});

});


parcelRegister("bfjnH", function(module, exports) {

$parcel$export(module.exports, "useOutgoingMailConfig", () => $1eb57df3368ecafc$export$a0d5dcab564be259);

var $5uXOq = parcelRequire("5uXOq");
const $1eb57df3368ecafc$export$a0d5dcab564be259 = ()=>{
    const [outgoingMailConfig, setOutgoingMailConfig] = (0, $5uXOq.useState)(null);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        const fetchOutgoingMailConfig = async ()=>{
            try {
                setLoading(true);
                const response = await fetch('/rest/jira-mail-plugin/1.0/outgoingMail/config');
                if (!response.ok) throw new Error('Failed to fetch outgoingMailConfig');
                const data = await response.json();
                setOutgoingMailConfig(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                setError(e.message);
            } finally{
                setLoading(false);
            }
        };
        fetchOutgoingMailConfig();
    }, []);
    return {
        outgoingMailConfig: outgoingMailConfig,
        loading: loading,
        error: error
    };
};

});

parcelRegister("cdbNa", function(module, exports) {

$parcel$export(module.exports, "EnableOutgoingMailInfo", () => $f4556eeaa26c4bdf$export$c75e44dac0fdc638);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7nnPp = parcelRequire("7nnPp");


var $8Q4sF = parcelRequire("8Q4sF");

var $koVbs = parcelRequire("koVbs");

var $82RmH = parcelRequire("82RmH");
const $f4556eeaa26c4bdf$var$Bold = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, children);
const $f4556eeaa26c4bdf$export$c75e44dac0fdc638 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const siteUrl = window.location.hostname;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4556eeaa26c4bdf$var$OutgoingMailErrorText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7nnPp))), {
        size: "medium",
        label: "",
        primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
        message: formatMessage((0, $82RmH.messages).configDisabledAndHasFailureLogs, {
            boldStart: '{boldStart}',
            boldEnd: '{boldEnd}',
            siteUrl: siteUrl
        }),
        componentsMapping: {
            bold: $f4556eeaa26c4bdf$var$Bold
        }
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f4556eeaa26c4bdf$var$OutgoingMailErrorText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4utpp _19bvidpf _1e0c1o8l _154iidpf _kqsw1if8 _1pbyowjs _bfhkvuon _1bsb1osq _vr2wh2mm _1t1812x7 _1tnd12x7",
            __cmplp.className
        ])
    });
});

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("8Q4sF", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $7c8c20575fbc9bfc$export$200d7bd7633253ce);

var $5uXOq = parcelRequire("5uXOq");

var $gHDlh = parcelRequire("gHDlh");

var $9Byym = parcelRequire("9Byym");
const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $5uXOq.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $9Byym.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $9Byym.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $9Byym.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $gHDlh.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $gHDlh.MalformedMessageError)) {
                (0, $gHDlh.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $gHDlh.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("gHDlh", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $ecff24857c176a60$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $ecff24857c176a60$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $ecff24857c176a60$export$40d900e818b9630e);

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $jcw0u.default)({
            meta: {
                packageName: packageName,
                id: (0, $5514815b06163219$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
        (0, $dJl1T.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $ecff24857c176a60$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("9Byym", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $84498158f946a67b$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $84498158f946a67b$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $84498158f946a67b$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $84498158f946a67b$export$d5170904651e91b1);

const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);

});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';



parcelRegister("82RmH", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a47f5e3387ec8e18$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a47f5e3387ec8e18$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    configDisabledAndHasFailureLogs: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.enable-outgoing-mail-info.config-disabled-and-has-failure-logs",
        "defaultMessage": "We couldn\u2019t refresh data because your Jira admin has disabled {boldStart}Outgoing Mail{boldEnd} for {siteUrl}."
    }
});

});


parcelRegister("gqagC", function(module, exports) {

$parcel$export(module.exports, "LogsTable", () => $cfefefa4701c53a4$export$58be81f5c6860851);

var $aegby = parcelRequire("aegby");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2hXfb = parcelRequire("2hXfb");

var $lj8SI = parcelRequire("lj8SI");


var $3bDjY = parcelRequire("3bDjY");
var $btzsC = parcelRequire("btzsC");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $bQGr5 = parcelRequire("bQGr5");

var $70BgY = parcelRequire("70BgY");

var $jGY5U = parcelRequire("jGY5U");

var $aDkDm = parcelRequire("aDkDm");
const $cfefefa4701c53a4$var$rowRenderer = (virtualRow, edgeData, formatMessage, projectKey)=>{
    const virtualRowIndex = virtualRow.index;
    if (!edgeData[virtualRowIndex]) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableRow, {
        "data-index": virtualRowIndex,
        height: virtualRow.size,
        translateY: virtualRow.start,
        key: virtualRowIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableCellSmall, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableCellSmall, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableCellMedium, null, formatMessage((0, $bQGr5.messages).loadMoreLogs)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableCellLarge, null));
    const { node: node } = edgeData[virtualRowIndex];
    const getDetailsCell = (details)=>{
        let errorMessageComponent;
        if (details) errorMessageComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aDkDm.ErrorMessage), {
            errorKey: details.errorKey ?? null,
            projectKey: projectKey,
            mailboxMessage: details.mailboxMessage ?? null,
            formatMessage: formatMessage
        });
        const TooltipComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$InlineDialog, {
                ...props,
                ref: ref
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$LogsDetails, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            position: "bottom-start",
            component: TooltipComponent,
            content: errorMessageComponent
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", tooltipProps, errorMessageComponent)));
    };
    const getNotificationTypeCell = (notificationType)=>{
        if (!notificationType) return null;
        const notificationName = (0, $aDkDm.getNotificationName)(notificationType, formatMessage);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
            appearance: "inprogress"
        }, notificationName);
    };
    const getCustomerNameCell = (customerName)=>{
        const TooltipComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$InlineDialog, {
                ...props,
                ref: ref
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$CustomerNameWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            position: "bottom-start",
            component: TooltipComponent,
            content: customerName
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", tooltipProps, customerName)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, edgeData.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableRow, {
        height: virtualRow.size,
        translateY: virtualRow.start,
        key: virtualRowIndex,
        "data-index": virtualRowIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableCellSmall, null, (0, $aDkDm.getLogDateTime)(node?.actionTimestamp)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableCellSmall, null, getNotificationTypeCell(node?.notificationActionType)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableCellMedium, null, getCustomerNameCell(node?.recipient?.email || node?.recipient?.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableCellLarge, null, getDetailsCell(node?.notificationDetails))));
};
const $cfefefa4701c53a4$export$ca3b93602b516d4a = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("table", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableHeaderCellSmall, null, formatMessage((0, $bQGr5.messages).tableHeaderDateTime)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableHeaderCellSmall, null, formatMessage((0, $bQGr5.messages).tableHeaderNotificationName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $bQGr5.messages).notificationTypeInfo)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$InfoIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hXfb))), {
            size: "small",
            primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
            label: ""
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableHeaderCellMedium, null, formatMessage((0, $bQGr5.messages).tableHeaderCustomerEmail)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableHeaderCellLarge, null, formatMessage((0, $bQGr5.messages).tableHeaderErrorMessage)))), children);
};
const $cfefefa4701c53a4$export$84fdb000f10c6779 = ({ data: data, virtualizer: virtualizer, projectKey: projectKey, outgoingMailConfigData: outgoingMailConfigData })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { outgoingMailConfig: outgoingMailConfig, error: error, loading: loading } = outgoingMailConfigData; // when we don't have customer logs i.e 0 logs
    if (!data.length && !error && !loading && outgoingMailConfig !== null) {
        if (!outgoingMailConfig?.enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
            eventName: "LogsTable RenderOutgoingMailConfigDisabledTextAndEmptyTable"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$export$ca3b93602b516d4a, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70BgY.NoDataEnableOutgoingMailInfo), null)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
            eventName: "LogsTable RenderEmptyTable"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$export$ca3b93602b516d4a, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jGY5U.NoRecords), null)));
    }
    if (data.length) // when we have customer logs show table of records
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        eventName: "LogsTable RenderTableWithData"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$InfiniteScrollTable, {
        totalSize: virtualizer.getTotalSize()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$Thead, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableHeaderCellSmall, null, formatMessage((0, $bQGr5.messages).tableHeaderDateTime)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableHeaderCellSmall, null, formatMessage((0, $bQGr5.messages).tableHeaderNotificationName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $bQGr5.messages).notificationTypeInfo)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$InfoIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hXfb))), {
            size: "small",
            primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
            label: ""
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableHeaderCellMedium, null, formatMessage((0, $bQGr5.messages).tableHeaderCustomerEmail)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableHeaderCellLarge, null, formatMessage((0, $bQGr5.messages).tableHeaderErrorMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$var$TableBody, null, virtualizer.getVirtualItems().map((virtualRow)=>$cfefefa4701c53a4$var$rowRenderer(virtualRow, data, formatMessage, projectKey)))));
    return null;
};
const $cfefefa4701c53a4$export$58be81f5c6860851 = ({ allEdges: allEdges, virtualizer: virtualizer, projectKey: projectKey, outgoingMailConfigData: outgoingMailConfigData })=>{
    const LogsDataFragment = (0, $aegby.default);
    const data = (0, $8Uumt.useFragment)(LogsDataFragment, allEdges);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfefefa4701c53a4$export$84fdb000f10c6779, {
        data: data,
        virtualizer: virtualizer,
        projectKey: projectKey,
        outgoingMailConfigData: outgoingMailConfigData
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfefefa4701c53a4$var$LogsDetails = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1bsb1ogm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfefefa4701c53a4$var$CustomerNameWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1bsb1ogy",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfefefa4701c53a4$var$TableCellSmall = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbka7h _1e0c116y _4cvr1h6o _1bah1y6m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfefefa4701c53a4$var$TableCellMedium = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb6o8t _1e0c116y _4cvr1h6o _1bah1y6m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfefefa4701c53a4$var$TableCellLarge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1qbz _1e0c116y _4cvr1h6o _1bah1y6m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfefefa4701c53a4$var$Thead = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "thead", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_154iidpf _kqsw1if8 _1pbyb4wl _bfhkvuon _n7zl1fwq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfefefa4701c53a4$var$TableHeaderCellSmall = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbka7h _1e0c116y _4cvr1h6o _1bah1y6m _kqsw1if8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfefefa4701c53a4$var$TableHeaderCellMedium = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb6o8t _1e0c116y _4cvr1h6o _1bah1y6m _kqsw1if8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfefefa4701c53a4$var$TableHeaderCellLarge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1qbz _1e0c116y _4cvr1h6o _1bah1y6m _kqsw1if8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfefefa4701c53a4$var$TableRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { translateY: translateY, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`),
            "--_1eykf4m": (0, $lD23V.default)(`translateY(${__cmplp.translateY}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsb1osq _4t3i2nrh _t9ec1inw _19pku2gc _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfefefa4701c53a4$var$TableBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "tbody", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1kw7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfefefa4701c53a4$var$InfiniteScrollTable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "table", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { totalSize: totalSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_r9fzc2": (0, $lD23V.default)(`${__cmplp.totalSize}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1651 _1bsb1osq _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfefefa4701c53a4$var$InlineDialog = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $btzsC.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7vuon _2rko1l7b _16qs1mxi _p12fnklw _vchh18uv _ca0q7vkz _u5f31tcg _n3td7vkz _19bv1tcg _1nmz1hna",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfefefa4701c53a4$var$InfoIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66 _1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aegby", function(module, exports) {

$parcel$export(module.exports, "default", () => $789002b9d6b07117$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<637e5e0f4363eff38eef07c9273e05a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $789002b9d6b07117$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "logsTable_logEdges",
    "selections": [
        {
            "concreteType": "AquaOutgoingEmailLogItem",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "notificationActionType"
                },
                {
                    "kind": "ScalarField",
                    "name": "actionTimestamp"
                },
                {
                    "concreteType": "AquaNotificationDetails",
                    "kind": "LinkedField",
                    "name": "notificationDetails",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "errorKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "mailboxMessage"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "recipient",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "email"
                                }
                            ],
                            "type": "AtlassianAccountUser"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ],
                            "type": "CustomerUser"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "AquaOutgoingEmailLogItemEdge"
};
$789002b9d6b07117$var$node.hash = "48e23bd9eac76036619daebc8ad9509f";
var $789002b9d6b07117$export$2e2bcd8739ae039 = $789002b9d6b07117$var$node;

});

parcelRegister("bQGr5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $97402055f73a3627$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $97402055f73a3627$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    renderingFailed: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.rendering-failed",
        "defaultMessage": "Internal error. {linkStart}Resend the invite{linkEnd} later."
    },
    requestTooLong: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.request-too-long",
        "defaultMessage": "Notification size is greater than 6 MB. Reduce the size of customer invite template."
    },
    emailValidationFailure: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.email-validation-failure",
        "defaultMessage": "Unable to validate customer\u2019s email address. Check the format and invite again."
    },
    rfc1918LanIpRoutingFailure: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.rfc-1918-lan-ip-routing-failure",
        "defaultMessage": "Customer\u2019s email address belongs to a private address space. Invite again using the correct email address."
    },
    suppressedMessageWhenUnsuppressionIsEnabled: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.suppressed-message-when-unsuppression-is-enabled",
        "defaultMessage": "Customer\u2019s email address is on a suppression list. Resend invite from the {linkStart}Customers page{linkEnd}."
    },
    suppressedMessageWhenUnsuppressionIsDisabled: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.suppressed-message-when-unsuppression-is-disabled",
        "defaultMessage": "Customer email added to the suppression list."
    },
    bounced: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.bounced",
        "defaultMessage": "Error from email provider"
    },
    emailNotificationLimitReached: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.email-notification-limit-reached",
        "defaultMessage": "Reached the email notifications limit for {siteUrl}."
    },
    defaultValue: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.default-value",
        "defaultMessage": "Unspecified error. Try again later."
    },
    tableHeaderDateTime: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.table-header-date-time",
        "defaultMessage": "Date and time"
    },
    tableHeaderNotificationName: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.table-header-notification-name",
        "defaultMessage": "Notification name"
    },
    tableHeaderCustomerEmail: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.table-header-customer-email",
        "defaultMessage": "Customer name"
    },
    tableHeaderErrorMessage: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.table-header-error-message",
        "defaultMessage": "What went wrong"
    },
    notificationTypeInfo: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.notification-type-info",
        "defaultMessage": "Includes customer invites only"
    },
    customerInvited: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.customer-invited",
        "defaultMessage": "Customer invited"
    },
    loadMoreLogs: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.load-more-logs",
        "defaultMessage": "Loading more logs..."
    }
});

});

parcelRegister("70BgY", function(module, exports) {

$parcel$export(module.exports, "NoDataEnableOutgoingMailInfo", () => $726fa234f1aca424$export$31d032be89b0df83);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7nnPp = parcelRequire("7nnPp");


var $8Q4sF = parcelRequire("8Q4sF");

var $2JXc1 = parcelRequire("2JXc1");

var $koVbs = parcelRequire("koVbs");

var $1pnuQ = parcelRequire("1pnuQ");
const $726fa234f1aca424$var$Bold = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, children);
const $726fa234f1aca424$export$31d032be89b0df83 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const siteUrl = window.location.hostname;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($726fa234f1aca424$var$OutgoingMailErrorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($726fa234f1aca424$var$OutgoingMailInfoWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2JXc1.default), {
        height: "222",
        width: "191",
        alt: "no failure logs"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($726fa234f1aca424$var$OutgoingMailErrorText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7nnPp))), {
        size: "medium",
        label: "",
        primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
        message: formatMessage((0, $1pnuQ.messages).configDisabledAndNoFailureLogs, {
            boldStart: '{boldStart}',
            boldEnd: '{boldEnd}',
            siteUrl: siteUrl
        }),
        componentsMapping: {
            bold: $726fa234f1aca424$var$Bold
        }
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $726fa234f1aca424$var$OutgoingMailErrorContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3idgin",
            __cmplp.className
        ])
    });
});
const $726fa234f1aca424$var$OutgoingMailInfoWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s8utpp _18u0idpf _y3gn1h6o _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $726fa234f1aca424$var$OutgoingMailErrorText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4utpp _19bvidpf _1e0c1o8l _vr2wh2mm _1t1812x7 _1tnd12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2JXc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5d3fe7c3133ec07$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = mmwr66tqxzps49fhmn4694w
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/mmwr66tqxzps49fhmn4694w

var $dCLgq = parcelRequire("dCLgq");

var $cid60 = parcelRequire("cid60");

var $6y2Qu = parcelRequire("6y2Qu");
const $c5d3fe7c3133ec07$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6y2Qu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($cid60))
});
var $c5d3fe7c3133ec07$export$2e2bcd8739ae039 = $c5d3fe7c3133ec07$var$Illustration;
// for advanced use only
const $c5d3fe7c3133ec07$export$a179c88182cb9d56 = [
    0,
    0,
    191,
    222
];

});
parcelRegister("cid60", function(module, exports) {
module.exports = new URL("lock-closed-darkmode.26d51607.svg", import.meta.url).toString();

});

parcelRegister("6y2Qu", function(module, exports) {
module.exports = new URL("lock-closed.22dbfd6e.svg", import.meta.url).toString();

});


parcelRegister("1pnuQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8d81efaa466daa45$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8d81efaa466daa45$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    configDisabledAndNoFailureLogs: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.no-data-enable-outgoing-mail-info.config-disabled-and-no-failure-logs",
        "defaultMessage": "No data available as {boldStart}Outgoing Mail{boldEnd} is disabled for {siteUrl}."
    }
});

});


parcelRegister("jGY5U", function(module, exports) {

$parcel$export(module.exports, "NoRecords", () => $ee3b8ba1d9af1ba0$export$cdb065a719ea8884);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3a3KV = parcelRequire("3a3KV");

var $koVbs = parcelRequire("koVbs");

var $lSOxN = parcelRequire("lSOxN");
const $ee3b8ba1d9af1ba0$export$cdb065a719ea8884 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ee3b8ba1d9af1ba0$var$AllGoodContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ee3b8ba1d9af1ba0$var$AllGoodContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ee3b8ba1d9af1ba0$var$imageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3a3KV.default), {
        height: "150",
        width: "139",
        alt: "no failure logs"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h5", null, formatMessage((0, $lSOxN.messages).configEnabledAndNoFailureLogsMainText))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ee3b8ba1d9af1ba0$var$AllGoodContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3idgin",
            __cmplp.className
        ])
    });
});
const $ee3b8ba1d9af1ba0$var$AllGoodContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _13tb1ejb _1gtfidpf",
            __cmplp.className
        ])
    });
});
const $ee3b8ba1d9af1ba0$var$imageContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'center'
});

});
parcelRegister("3a3KV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f7e7138359f79b9$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = vb8b89gnsq3h8xbh8jsqkgkp
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/vb8b89gnsq3h8xbh8jsqkgkp

var $dCLgq = parcelRequire("dCLgq");

var $gtj36 = parcelRequire("gtj36");
const $2f7e7138359f79b9$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($gtj36)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($gtj36))
});
var $2f7e7138359f79b9$export$2e2bcd8739ae039 = $2f7e7138359f79b9$var$Illustration;
// for advanced use only
const $2f7e7138359f79b9$export$a179c88182cb9d56 = [
    0,
    0,
    226,
    244
];

});
parcelRegister("gtj36", function(module, exports) {
module.exports = new URL("service-success.e99f1cd7.svg", import.meta.url).toString();

});


parcelRegister("lSOxN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $91f9c0da35f1047c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $91f9c0da35f1047c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    configEnabledAndNoFailureLogsMainText: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.no-records.config-enabled-and-no-failure-logs-main-text",
        "defaultMessage": "All set! Customer notifications for your project went through successfully!"
    }
});

});


parcelRegister("aDkDm", function(module, exports) {

$parcel$export(module.exports, "getLogDateTime", () => $14bacaa4835d9364$export$fbe52a537db76a48);
$parcel$export(module.exports, "ErrorMessage", () => $14bacaa4835d9364$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "getNotificationName", () => $14bacaa4835d9364$export$dc44215dd42a02db);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $8Q4sF = parcelRequire("8Q4sF");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bQGr5 = parcelRequire("bQGr5");
const $14bacaa4835d9364$export$fbe52a537db76a48 = (dateString)=>{
    if (dateString) {
        const dateObj = new Date(dateString);
        const year = dateObj.getFullYear();
        const month = dateObj.toLocaleString('en-us', {
            month: 'short'
        });
        const day = dateObj.getDate();
        const hours = dateObj.getUTCHours();
        const minutes = dateObj.getUTCMinutes();
        // Format the output date string
        const outputDateString = `${month} ${day}, ${year} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        return outputDateString;
    }
    return dateString;
};
const $14bacaa4835d9364$var$FormattedErrorWithLinkButton = ({ href: href, errorMessage: errorMessage, onLinkButtonClicked: onLinkButtonClicked })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
        componentsMapping: {
            link: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    appearance: "link",
                    spacing: "none",
                    href: href,
                    target: "_blank",
                    onClick: onLinkButtonClicked
                }, props.children)
        },
        message: formatMessage(errorMessage, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        })
    });
};
const $14bacaa4835d9364$var$FormattedErrorText = ({ errorMessage: errorMessage })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage(errorMessage));
};
const $14bacaa4835d9364$export$300e9e75480e4710 = ({ mailboxMessage: mailboxMessage, formatMessage: formatMessage })=>{
    const bouncedMessage = `${formatMessage((0, $bQGr5.messages).bounced)}: ${mailboxMessage}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, bouncedMessage);
};
const $14bacaa4835d9364$export$915e9e7bd4f0f96d = ({ errorKey: errorKey, projectKey: projectKey, mailboxMessage: mailboxMessage, formatMessage: formatMessage })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onInternalErrorResendInviteClicked = (0, $5uXOq.useCallback)(()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'internalErrorResendInviteLink',
            action: 'clicked'
        }), 'internalErrorResendInvite'), [
        createAnalyticsEvent
    ]);
    const suppressedErrorGoToCustomersPageClicked = (0, $5uXOq.useCallback)(()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'suppressedErrorGoToCustomersPageLink',
            action: 'clicked'
        }), 'suppressedErrorGoToCustomersPage'), [
        createAnalyticsEvent
    ]);
    switch(errorKey && errorKey.toLowerCase()){
        case 'rendering_failed':
        case 'retrieve_configuration_failed':
        case 'retryable_am_failure':
        case 'unknown_failure':
            {
                const href = `/jira/servicedesk/projects/${projectKey}/customers`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($14bacaa4835d9364$var$FormattedErrorWithLinkButton, {
                    href: href,
                    errorMessage: (0, $bQGr5.messages).renderingFailed,
                    onLinkButtonClicked: onInternalErrorResendInviteClicked
                });
            }
        case 'request_too_long':
        case 'request_size_exceeded':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($14bacaa4835d9364$var$FormattedErrorText, {
                errorMessage: (0, $bQGr5.messages).requestTooLong
            });
        case 'email_validation_failure':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($14bacaa4835d9364$var$FormattedErrorText, {
                errorMessage: (0, $bQGr5.messages).emailValidationFailure
            });
        case 'rfc1918_lan_ip_routing_failure':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($14bacaa4835d9364$var$FormattedErrorText, {
                errorMessage: (0, $bQGr5.messages).rfc1918LanIpRoutingFailure
            });
        case 'suppressed':
            {
                const errorMessage = (0, $bQGr5.messages).suppressedMessageWhenUnsuppressionIsEnabled;
                const href = `/jira/servicedesk/projects/${projectKey}/customers`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($14bacaa4835d9364$var$FormattedErrorWithLinkButton, {
                    href: href,
                    errorMessage: errorMessage,
                    onLinkButtonClicked: suppressedErrorGoToCustomersPageClicked
                });
            }
        case 'email_notification_limit_reached':
            {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                const siteUrl = window.location.hostname;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                    values: {
                        siteUrl: siteUrl
                    },
                    ...(0, $bQGr5.messages).emailNotificationLimitReached
                });
            }
        case 'bounced':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($14bacaa4835d9364$export$300e9e75480e4710, {
                mailboxMessage: mailboxMessage,
                formatMessage: formatMessage
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($14bacaa4835d9364$var$FormattedErrorText, {
                errorMessage: (0, $bQGr5.messages).defaultValue
            });
    }
};
const $14bacaa4835d9364$export$dc44215dd42a02db = (notificationType, formatMessage)=>{
    switch(notificationType.toLowerCase()){
        case 'customer_invite':
            return formatMessage((0, $bQGr5.messages).customerInvited);
        default:
            return '';
    }
};

});


parcelRegister("9ePAM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a12820399bdc9a0f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a12820399bdc9a0f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.title",
        "defaultMessage": "Customer notification logs"
    },
    projects: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.projects",
        "defaultMessage": "Projects"
    }
});

});

parcelRegister("ePYuj", function(module, exports) {

$parcel$export(module.exports, "NotificationAppSubHeader", () => $140d79e29f589156$export$8f6ed0d18980040c);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cgL5K = parcelRequire("cgL5K");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $jZrSh = parcelRequire("jZrSh");

var $fe4fl = parcelRequire("fe4fl");
const $140d79e29f589156$export$8f6ed0d18980040c = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const articleId = '3VlB3YNCvdJ8c8zzo50d85';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onLearnMoreLinkClicked = (0, $5uXOq.useCallback)(()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'learnMoreAboutCustomerNotificationLogsLink',
            action: 'clicked'
        }), 'learnMoreAboutCustomerNotificationLogs'), [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($140d79e29f589156$var$SubHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $fe4fl.messages).knowMoreInfoText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZrSh.InProductHelpLink), {
        href: "",
        inProductHelpArticleId: articleId,
        learnMoreText: formatMessage((0, $fe4fl.messages).learnMoreText),
        onClick: onLearnMoreLinkClicked
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $140d79e29f589156$var$SubHeaderContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1fjn1nu9 _11pqu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jZrSh", function(module, exports) {

$parcel$export(module.exports, "InProductHelpLink", () => $32955e92f3319f63$export$4fe0f115bd124cae);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $e4yMr = parcelRequire("e4yMr");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8oe80 = parcelRequire("8oe80");

var $41j30 = parcelRequire("41j30");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $5Zxxp = parcelRequire("5Zxxp");
const $32955e92f3319f63$export$4fe0f115bd124cae = ({ href: href, inProductHelpArticleId: inProductHelpArticleId, learnMoreText: learnMoreText, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const learnMoreLinkV2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($32955e92f3319f63$var$LinkV2WithAnalytics, {
        target: "_blank",
        rel: "noopener noreferrer",
        href: href,
        onClick: onClick
    }, learnMoreText);
    const learnMoreLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
        target: "_blank",
        rel: "noopener noreferrer",
        href: href,
        onClick: onClick
    }, learnMoreText);
    const currentLearnMoreLink = (0, $4R6GH.fg)('in_product_help_link') ? learnMoreLinkV2 : learnMoreLink;
    if (inProductHelpArticleId === undefined && !(0, $4R6GH.fg)('help_panel_as_link')) return currentLearnMoreLink;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($32955e92f3319f63$var$LinkStyledHelpPanelButton, {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "servicedesk-common.components.in-product-help-link.link-styled-help-panel-button",
        fallbackComponent: currentLearnMoreLink,
        articleId: inProductHelpArticleId,
        onClick: onClick,
        appearance: "link",
        spacing: "none",
        href: href
    }, (0, $co1wz.ff)('itsm-agni-25q1-a11y-fixes-_skehn') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $32955e92f3319f63$var$linkTextContainerstyles
    }, learnMoreText) : learnMoreText);
};
const $32955e92f3319f63$var$linkTextContainerstyles = (0, $8CUq3.xcss)({
    whiteSpace: 'normal'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $32955e92f3319f63$var$LinkStyledHelpPanelButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $5Zxxp.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4bfu18uv _1hms8stv _ajmmnqa1 _1r5p1kw7",
            __cmplp.className
        ])
    });
});
const $32955e92f3319f63$var$LinkV2WithAnalytics = (0, $8oe80.default)('link', {
    onClick: 'clicked'
})((0, $e4yMr.default));

});
parcelRegister("41j30", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c2f3c33a6194375$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8oe80 = parcelRequire("8oe80");

var $dIdda = parcelRequire("dIdda");
function $7c2f3c33a6194375$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), rest, children);
}
var $7c2f3c33a6194375$export$2e2bcd8739ae039 = (0, $8oe80.default)('link', {
    onClick: 'clicked'
})($7c2f3c33a6194375$var$Link);

});

parcelRegister("5Zxxp", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $b0d1b3c2fea05784$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $b0d1b3c2fea05784$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $bHDKL = parcelRequire("bHDKL");

var $e4yMr = parcelRequire("e4yMr");

var $jpY8v = parcelRequire("jpY8v");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $6BNJk = parcelRequire("6BNJk");

var $kspz4 = parcelRequire("kspz4");

var $hsmeR = parcelRequire("hsmeR");
const $b0d1b3c2fea05784$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $kspz4.useHelpPanelActions)();
    const isIphEnabled = ((0, $co1wz.ff)('iph.enabled') || (0, $4R6GH.fg)('help_panel_as_link')) && !(0, $jpY8v.isIE11)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $6BNJk.HELP_PANEL_ID), (0, $6BNJk.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: (0, $bHDKL.ARTICLE_TYPE)[type]
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: (0, $bHDKL.ARTICLE_TYPE)[type]
            }
        });
    };
    return isIphEnabled ? handleOnClick : undefined;
};
const $b0d1b3c2fea05784$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, href: href, ...props })=>{
    const onOpenInProductHelpArticle = $b0d1b3c2fea05784$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        if ((0, $4R6GH.fg)('help_panel_as_link')) event.preventDefault();
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, (0, $bHDKL.ARTICLE_TYPE)[type]);
    };
    if ((0, $4R6GH.fg)('help_panel_as_link')) return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        ...props,
        onClick: handleOnClick,
        href: href ?? 'https://support.atlassian.com',
        appearance: "default",
        testId: props.testId
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fallbackComponent);
    return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ...props,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fallbackComponent);
};
var $b0d1b3c2fea05784$export$2e2bcd8739ae039 = $b0d1b3c2fea05784$var$HelpPanelLink;
const $b0d1b3c2fea05784$var$buttonWrapperStyles = null;

});


parcelRegister("fe4fl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $28db8a315512ab44$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $28db8a315512ab44$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    knowMoreInfoText: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-app-sub-header.know-more-info-text",
        "defaultMessage": "View undelivered notifications in the last 21 days. "
    },
    learnMoreText: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-app-sub-header.learn-more-text",
        "defaultMessage": "Learn more about customer notification logs."
    }
});

});


parcelRegister("kH3pk", function(module, exports) {

$parcel$export(module.exports, "NotificationLogsTabLayout", () => $035b2a23228d11ed$export$8c09fdd1a5e9a6e3);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fuUnn = parcelRequire("fuUnn");
var $jbeEq = parcelRequire("jbeEq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $cS37j = parcelRequire("cS37j");

var $39xOx = parcelRequire("39xOx");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $bfjnH = parcelRequire("bfjnH");

var $h6N5n = parcelRequire("h6N5n");

var $jrqHH = parcelRequire("jrqHH");

var $jNffj = parcelRequire("jNffj");

var $1Cifx = parcelRequire("1Cifx");
const $035b2a23228d11ed$var$GetNotificationLogsBreadcrumbs = (projectContext, breadcrumbRoot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbeEq.default), {
        onExpand: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
        text: breadcrumbRoot,
        href: "/jira/projects"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
        text: `${projectContext?.projectName}`,
        href: `/browse/${projectContext?.projectKey}`
    }));
const $035b2a23228d11ed$export$8c09fdd1a5e9a6e3 = ({ projectContext: projectContext })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const breadcrumbRoot = formatMessage((0, $jrqHH.messages).projects);
    const breadcrumbs = $035b2a23228d11ed$var$GetNotificationLogsBreadcrumbs(projectContext, breadcrumbRoot);
    const outgoingMailConfigData = (0, $bfjnH.useOutgoingMailConfig)();
    const { outgoingMailConfig: outgoingMailConfig, error: error, loading: loading } = outgoingMailConfigData;
    if (error) (0, $jcw0u.default)({
        meta: {
            id: 'ErrorFetchingOutgoingMailConfigDataInTabsLayout',
            packageName: 'jiraSpaAppsServicedeskNotificationLogs',
            teamName: 'spartans'
        },
        error: new Error(error),
        sendToPrivacyUnsafeSplunk: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "CustomerNotificationLogsInTabsLayout",
        packageName: "jiraSpaAppsServicedeskNotificationLogs",
        teamName: "spartans"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "customerNotificationLogs",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $035b2a23228d11ed$var$notificationAppStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        breadcrumbs: breadcrumbs
    }, formatMessage((0, $jrqHH.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jNffj.NotificationAppSubHeader), null), outgoingMailConfig !== null && !error && !loading && !outgoingMailConfig?.enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        eventName: "LogsTableInTabsLayout OutGoingMailDisabledText"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h6N5n.EnableOutgoingMailInfo), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Cifx.NotificationTabs), {
        projectContext: projectContext,
        outgoingMailConfigData: outgoingMailConfigData
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)));
};
const $035b2a23228d11ed$var$notificationAppStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.500',
    marginRight: 'space.500'
});

});
parcelRegister("h6N5n", function(module, exports) {

$parcel$export(module.exports, "EnableOutgoingMailInfo", () => $50f0893185fbc96c$export$c75e44dac0fdc638);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7nnPp = parcelRequire("7nnPp");


var $8Q4sF = parcelRequire("8Q4sF");

var $koVbs = parcelRequire("koVbs");

var $dcwaU = parcelRequire("dcwaU");
const $50f0893185fbc96c$var$Bold = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, children);
const $50f0893185fbc96c$export$c75e44dac0fdc638 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const siteUrl = window.location.hostname;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($50f0893185fbc96c$var$OutgoingMailErrorText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7nnPp))), {
        size: "medium",
        label: "",
        primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
        message: formatMessage((0, $dcwaU.messages).configDisabledAndHasFailureLogs, {
            boldStart: '{boldStart}',
            boldEnd: '{boldEnd}',
            siteUrl: siteUrl
        }),
        componentsMapping: {
            bold: $50f0893185fbc96c$var$Bold
        }
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $50f0893185fbc96c$var$OutgoingMailErrorText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4utpp _19bvidpf _1e0c1o8l _154iidpf _kqsw1if8 _1pbyowjs _bfhkvuon _1bsb1osq _vr2wh2mm _1t1812x7 _1tnd12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dcwaU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a40a3a906225b436$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a40a3a906225b436$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    configDisabledAndHasFailureLogs: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.enable-outgoing-mail-info.config-disabled-and-has-failure-logs",
        "defaultMessage": "We couldn\u2019t refresh data because your Jira admin has disabled {boldStart}Outgoing Mail{boldEnd} for {siteUrl}."
    }
});

});


parcelRegister("jrqHH", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d6fefbde36dd395e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d6fefbde36dd395e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.title",
        "defaultMessage": "Customer notification logs"
    },
    projects: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.projects",
        "defaultMessage": "Projects"
    }
});

});

parcelRegister("jNffj", function(module, exports) {

$parcel$export(module.exports, "NotificationAppSubHeader", () => $6620b65b00a8c86d$export$8f6ed0d18980040c);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $jZrSh = parcelRequire("jZrSh");

var $ck7yD = parcelRequire("ck7yD");
const $6620b65b00a8c86d$export$8f6ed0d18980040c = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const articleId = '3VlB3YNCvdJ8c8zzo50d85';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onLearnMoreLinkClicked = (0, $5uXOq.useCallback)(()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'learnMoreAboutCustomerNotificationLogsLink',
            action: 'clicked'
        }), 'learnMoreAboutCustomerNotificationLogs'), [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6620b65b00a8c86d$var$SubHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-app-sub-header.span"
    }, formatMessage((0, $ck7yD.messages).knowMoreInfoText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZrSh.InProductHelpLink), {
        href: "",
        inProductHelpArticleId: articleId,
        learnMoreText: formatMessage((0, $ck7yD.messages).learnMoreText),
        onClick: onLearnMoreLinkClicked
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6620b65b00a8c86d$var$SubHeaderContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi _1kdcu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ck7yD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7327e8745c0e5367$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7327e8745c0e5367$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    knowMoreInfoText: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-app-sub-header.know-more-info-text",
        "defaultMessage": "View undelivered email notifications for the last 21 days. "
    },
    learnMoreText: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-app-sub-header.learn-more-text",
        "defaultMessage": "Read more about customer notification logs. "
    }
});

});


parcelRegister("1Cifx", function(module, exports) {

$parcel$export(module.exports, "NotificationTabs", () => $4639157a6fdfd4fc$export$5dd40b7e2c20a9df);

var $jJzIg = parcelRequire("jJzIg");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $fphHl = parcelRequire("fphHl");
var $jxIT3 = parcelRequire("jxIT3");
var $cte3m = parcelRequire("cte3m");
var $8TQB5 = parcelRequire("8TQB5");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $3OoGN = parcelRequire("3OoGN");

var $4W8YQ = parcelRequire("4W8YQ");
const $4639157a6fdfd4fc$export$2ddb90ad54e5f587 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4639157a6fdfd4fc$var$PanelWrapper, {
        "data-testid": testId
    }, children);
const $4639157a6fdfd4fc$export$2b91517d6d5b4365 = (0, $jJzIg.default);
const $4639157a6fdfd4fc$export$5dd40b7e2c20a9df = ({ projectContext: projectContext, outgoingMailConfigData: outgoingMailConfigData })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const tabTitles = [
        'customerInvite',
        'issueFailure'
    ];
    const [selectedTab, setSelectedTab] = (0, $5uXOq.useState)('CUSTOMER_INVITE');
    const cloudId = (0, $koeKL.useCloudId)();
    const projectId = projectContext?.projectId;
    const projectKey = projectContext?.projectKey;
    // // Create a unique fetchKey for each selectedTab
    const fetchKey = (0, $5uXOq.useMemo)(()=>selectedTab, [
        selectedTab
    ]);
    // Use useLazyLoadQuery to fetch data
    const emailData = (0, $8Uumt.useLazyLoadQuery)($4639157a6fdfd4fc$export$2b91517d6d5b4365, {
        cloudId: cloudId,
        projectId: projectId,
        notificationType: selectedTab === 'CUSTOMER_INVITE' ? null : 'CUSTOMER_NOTIFICATION.ISSUE',
        notificationActionType: selectedTab === 'CUSTOMER_INVITE' ? 'CUSTOMER_INVITE' : null
    }, {
        fetchKey: fetchKey,
        fetchPolicy: 'network-only'
    });
    // Handle tab change
    const handleTabChange = (index)=>{
        if (index === 0) {
            const analyticsEventForCustomerInvite = createAnalyticsEvent({
                actionSubject: 'customerInviteNotificationTabs',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEventForCustomerInvite);
            setSelectedTab('CUSTOMER_INVITE');
        }
        if (index === 1) {
            const analyticsEventForIssueNotification = createAnalyticsEvent({
                actionSubject: 'issueNotificationNotificationTabs',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEventForIssueNotification);
            setSelectedTab('ISSUE_NOTIFICATION');
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fphHl.default), {
        onChange: handleTabChange,
        id: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cte3m.default), null, tabTitles.map((title, index)=>{
        if (title === 'customerInvite') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jxIT3.default), {
            key: index,
            testId: "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.tab-1"
        }, formatMessage((0, $3OoGN.messages).customerInvite), ' ');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jxIT3.default), {
            key: index,
            testId: "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.tab-2"
        }, formatMessage((0, $3OoGN.messages).issueFailure));
    })), tabTitles.map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8TQB5.default), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4639157a6fdfd4fc$export$2ddb90ad54e5f587, {
            testId: `spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.panel-${index + 1}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4W8YQ.NotificationLogsTable), {
            emailData: emailData,
            projectKey: projectKey,
            outgoingMailConfigData: outgoingMailConfigData,
            selectedTab: selectedTab
        })))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4639157a6fdfd4fc$var$PanelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jJzIg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4efbb2d9b0f0d09$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9307e9f95e8c78bd440c81d2698d5850>>
 * @relayHash 054b277f59f52ab3975e718bd8675f5b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 13a31a15254e1fa836fd63fd2ceed4a4db3667506bd24eaf3ab068d59c80452f
const $b4efbb2d9b0f0d09$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "notificationActionType"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "notificationType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "notificationTabsQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "notificationTabsQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "AquaOutgoingEmailLogsQueryApi",
                    "kind": "LinkedField",
                    "name": "aquaOutgoingEmailLogs",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "notificationActionType",
                                    "variableName": "notificationActionType"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "notificationType",
                                    "variableName": "notificationType"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectId",
                                    "variableName": "projectId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "GetNotificationLogs",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v5 /*: any*/ ,
                                            "concreteType": "AquaOutgoingEmailLogConnection",
                                            "kind": "LinkedField",
                                            "name": "logs",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AquaOutgoingEmailLogItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AquaOutgoingEmailLogItem",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AquaIssueContext",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueContext",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssue",
                                                                            "kind": "LinkedField",
                                                                            "name": "issue",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "key"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "webUrl"
                                                                                },
                                                                                v6 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "notificationActionType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "actionTimestamp"
                                                                },
                                                                {
                                                                    "concreteType": "AquaNotificationDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "notificationDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "errorKey"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mailboxMessage"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "recipient",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "email"
                                                                                }
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "name"
                                                                                }
                                                                            ],
                                                                            "type": "CustomerUser"
                                                                        },
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "startCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasPreviousPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "logs(first:20)"
                                        },
                                        {
                                            "args": v5 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "aquaOutgoingEmail__logs",
                                            "kind": "LinkedHandle",
                                            "name": "logs"
                                        }
                                    ],
                                    "type": "AquaOutgoingEmailLog"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "13a31a15254e1fa836fd63fd2ceed4a4db3667506bd24eaf3ab068d59c80452f",
            "metadata": {},
            "name": "notificationTabsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b4efbb2d9b0f0d09$var$node.hash = "6f7dc50ebd258f4d9825a9fe7ca9f93f";
var $b4efbb2d9b0f0d09$export$2e2bcd8739ae039 = $b4efbb2d9b0f0d09$var$node;

});

parcelRegister("fphHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4810d6c8b7d5c95d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6QvkM = parcelRequire("6QvkM");

var $dWD6q = parcelRequire("dWD6q");

var $8emiI = parcelRequire("8emiI");
function $4810d6c8b7d5c95d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4810d6c8b7d5c95d$var$baseStyles = {
    name: "7i0hsw",
    styles: "display:flex;max-width:100%;min-height:0%;flex-basis:100%;flex-direction:column;flex-grow:1"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $4810d6c8b7d5c95d$var$tabsStyles = (0, $8emiI.getTabsStyles)();
const $4810d6c8b7d5c95d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4810d6c8b7d5c95d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dWD6q.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel);
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $4810d6c8b7d5c95d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $5uXOq.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $5uXOq.Children).toArray(children)// Don't include any conditional children
    .filter((child)=>Boolean(child));
    // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray;
    // Keep track of visited and add to a set
    const visited = (0, $5uXOq.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $5uXOq.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$4810d6c8b7d5c95d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $4810d6c8b7d5c95d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$4810d6c8b7d5c95d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return(// Only styles that affect the Tabs container itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTabPanel(),
    // which applies accessibility attributes that we use as a styling hook.
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $4810d6c8b7d5c95d$var$baseStyles,
            $4810d6c8b7d5c95d$var$tabsStyles
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dWD6q.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, tabPanelsWithContext)));
};
var $4810d6c8b7d5c95d$export$2e2bcd8739ae039 = $4810d6c8b7d5c95d$var$Tabs;

});
parcelRegister("dWD6q", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $b47499898157cfdc$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $b47499898157cfdc$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $b47499898157cfdc$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5uXOq = parcelRequire("5uXOq");
const $b47499898157cfdc$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$2054129d247c3102 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});

parcelRegister("8emiI", function(module, exports) {

$parcel$export(module.exports, "getTabsStyles", () => $899bec80a30728c7$export$dd5afd2190fb792c);
$parcel$export(module.exports, "getTabListStyles", () => $899bec80a30728c7$export$42a3c683c377bcb2);
$parcel$export(module.exports, "getTabListStylesOld", () => $899bec80a30728c7$export$f208f8acf591dbc2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $6VxaK = parcelRequire("6VxaK");
const $899bec80a30728c7$var$tabInlinePadding = "var(--ds-space-100, 8px)";
const $899bec80a30728c7$var$tabBlockPadding = "var(--ds-space-075, 6px)";
const $899bec80a30728c7$var$tabInlineMargin = "var(--ds-space-negative-100, -8px)";
// TODO this should probably be `border.width.indicator`
const $899bec80a30728c7$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
const $899bec80a30728c7$var$getTabPanelStyles = ()=>({
        flexGrow: 1,
        /*
     NOTE min-height set to 0% because of Firefox bug
     FF http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
   */ minHeight: '0%',
        display: 'flex'
    });
const $899bec80a30728c7$export$dd5afd2190fb792c = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tabpanel"]': $899bec80a30728c7$var$getTabPanelStyles(),
        // The hidden attribute doesn't work on flex elements
        // Change display to be none
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > [hidden]': {
            display: 'none'
        }
    });
const $899bec80a30728c7$var$tabLineStyles = {
    content: '""',
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $899bec80a30728c7$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $899bec80a30728c7$export$42a3c683c377bcb2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $899bec80a30728c7$export$916c8b0fccbb37d2(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $899bec80a30728c7$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$899bec80a30728c7$var$tabLineStyles,
            height: "var(--ds-border-width, 1px)",
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $6VxaK.tabLineColors).lineColor
        }
    });
const $899bec80a30728c7$export$916c8b0fccbb37d2 = ()=>{
    const colors = (0, $6VxaK.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$899bec80a30728c7$var$tabBlockPadding} ${$899bec80a30728c7$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$899bec80a30728c7$var$tabLineStyles,
                insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $6VxaK.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$899bec80a30728c7$var$tabLineStyles,
                insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $6VxaK.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$899bec80a30728c7$var$tabLineStyles,
                insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $6VxaK.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};
const $899bec80a30728c7$var$tabLineStylesOld = {
    content: '""',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $899bec80a30728c7$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $899bec80a30728c7$export$f208f8acf591dbc2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $899bec80a30728c7$export$442d081208938078(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $899bec80a30728c7$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$899bec80a30728c7$var$tabLineStylesOld,
            height: $899bec80a30728c7$var$underlineHeight,
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $6VxaK.tabLineColors).lineColor
        }
    });
const $899bec80a30728c7$export$442d081208938078 = ()=>{
    const colors = (0, $6VxaK.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$899bec80a30728c7$var$tabBlockPadding} ${$899bec80a30728c7$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$899bec80a30728c7$var$tabLineStylesOld,
                insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                borderBottom: `${$899bec80a30728c7$var$underlineHeight} solid ${(0, $6VxaK.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$899bec80a30728c7$var$tabLineStylesOld,
                insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                borderBottom: `${$899bec80a30728c7$var$underlineHeight} solid ${(0, $6VxaK.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$899bec80a30728c7$var$tabLineStylesOld,
                insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${$899bec80a30728c7$var$underlineHeight} solid ${(0, $6VxaK.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};

});
parcelRegister("6VxaK", function(module, exports) {

$parcel$export(module.exports, "tabColors", () => $874e3836572be4cc$export$5159a1ad8efe50bc);
$parcel$export(module.exports, "tabLineColors", () => $874e3836572be4cc$export$6be6fa4649b31472);

const $874e3836572be4cc$export$5159a1ad8efe50bc = {
    labelColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
    activeLabelColor: `var(--ds-text, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`,
    hoverLabelColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    selectedColor: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    focusBorderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`
};
const $874e3836572be4cc$export$6be6fa4649b31472 = {
    lineColor: `var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
    hoveredColor: "var(--ds-border, transparent)",
    activeColor: "var(--ds-border, transparent)",
    selectedColor: `var(--ds-border-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
};

});



parcelRegister("jxIT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a23bdf24c904bdb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jhVLw = parcelRequire("jhVLw");

var $cgL5K = parcelRequire("cgL5K");

var $eQ4wW = parcelRequire("eQ4wW");
/**
 * __Tab__
 *
 * Tab represents an indivudal Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $5a23bdf24c904bdb$var$Tab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $eQ4wW.useTab)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jhVLw.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex,
        ref: ref
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), {
        weight: "medium",
        color: "inherit",
        maxLines: 1
    }, children)));
});
var $5a23bdf24c904bdb$export$2e2bcd8739ae039 = $5a23bdf24c904bdb$var$Tab;

});
parcelRegister("eQ4wW", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $4d8616502e4de6b0$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $4d8616502e4de6b0$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $4d8616502e4de6b0$export$fae0121b5afe572d);

var $5uXOq = parcelRequire("5uXOq");

var $dWD6q = parcelRequire("dWD6q");
const $4d8616502e4de6b0$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $5uXOq.useContext)((0, $dWD6q.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $4d8616502e4de6b0$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $5uXOq.useContext)((0, $dWD6q.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $4d8616502e4de6b0$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $5uXOq.useContext)((0, $dWD6q.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("cte3m", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15f9538b451f314$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $eQ4wW = parcelRequire("eQ4wW");

var $dWD6q = parcelRequire("dWD6q");

var $8emiI = parcelRequire("8emiI");
function $e15f9538b451f314$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e15f9538b451f314$var$baseStyles = {
    name: "g0wsdz",
    styles: "display:flex;padding:var(--ds-space-0, 0px);position:relative"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $e15f9538b451f314$var$tabListStyles = (0, $8emiI.getTabListStyles)();
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $e15f9538b451f314$var$tabListStylesOld = (0, $8emiI.getTabListStylesOld)();
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $e15f9538b451f314$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $eQ4wW.useTabList)();
    const ref = /*#__PURE__*/ (0, $5uXOq.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $5uXOq.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $5uXOq.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $5uXOq.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dWD6q.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return(// Only styles that affect the TabList itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTab(),
    // which applies accessibility atributes that we use as a styling hook.
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "tablist",
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $e15f9538b451f314$var$baseStyles,
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $e15f9538b451f314$var$tabListStyles : $e15f9538b451f314$var$tabListStylesOld
        ]
    }, childrenArray.map((child, index)=>getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        }))));
};
var $e15f9538b451f314$export$2e2bcd8739ae039 = $e15f9538b451f314$var$TabList;

});

parcelRegister("8TQB5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca06f45af60382a8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jhVLw = parcelRequire("jhVLw");

var $eQ4wW = parcelRequire("eQ4wW");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $ca06f45af60382a8$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $eQ4wW.useTabPanel)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jhVLw.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children)));
};
var $ca06f45af60382a8$export$2e2bcd8739ae039 = $ca06f45af60382a8$var$TabPanel;

});

parcelRegister("3OoGN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b7743d2175162a1a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b7743d2175162a1a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    customerInvite: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.customer-invite",
        "defaultMessage": "Customer invitations"
    },
    issueFailure: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.issue-failure",
        "defaultMessage": "Request notifications"
    }
});

});

parcelRegister("4W8YQ", function(module, exports) {

$parcel$export(module.exports, "NotificationLogsTable", () => $6b7c2ece765359d1$export$12ff1d4ce191bd1e);

var $ajbwj = parcelRequire("ajbwj");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9suPc = parcelRequire("9suPc");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $5oFIy = parcelRequire("5oFIy");

var $ib5lJ = parcelRequire("ib5lJ");
const $6b7c2ece765359d1$var$PAZE_SIZE = 30;
const $6b7c2ece765359d1$var$NO_ERROR = 'No Error';
const $6b7c2ece765359d1$export$12ff1d4ce191bd1e = ({ emailData: emailData, projectKey: projectKey, outgoingMailConfigData: outgoingMailConfigData, selectedTab: selectedTab })=>{
    const { data: data, loadNext: loadNext } = (0, $8Uumt.usePaginationFragment)((0, $ajbwj.default), emailData);
    if (!data || !data.aquaOutgoingEmailLogs) {
        const validationError = new Error('Validation Error');
        (0, $jcw0u.default)({
            meta: {
                id: 'LogsQueryReturnedValidationErrorInTabsLayout',
                packageName: 'jiraSpaAppsServicedeskNotificationLogs',
                teamName: 'spartans'
            },
            error: validationError,
            sendToPrivacyUnsafeSplunk: true
        });
        throw validationError;
    }
    const responseType = data.aquaOutgoingEmailLogs?.GetNotificationLogs?.__typename;
    if (responseType === 'QueryError') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errorMessage = data.aquaOutgoingEmailLogs?.GetNotificationLogs?.message;
        const queryError = new Error(errorMessage);
        (0, $jcw0u.default)({
            meta: {
                id: 'LogsQueryReturnedErrorInTabsLayout',
                packageName: 'jiraSpaAppsServicedeskNotificationLogs',
                teamName: 'spartans'
            },
            error: queryError,
            sendToPrivacyUnsafeSplunk: true
        });
        throw queryError;
    }
    const hasMoreData = data.aquaOutgoingEmailLogs?.GetNotificationLogs?.logs?.pageInfo.hasNextPage;
    const allRows = data;
    const allRowEdges = allRows.aquaOutgoingEmailLogs?.GetNotificationLogs?.logs?.edges;
    const hasError = allRows.aquaOutgoingEmailLogs?.GetNotificationLogs?.identifier ? allRows.aquaOutgoingEmailLogs?.GetNotificationLogs.message : $6b7c2ece765359d1$var$NO_ERROR;
    const parentRef = (0, $5uXOq.useRef)(null);
    const getRowHeight = (0, $5uXOq.useCallback)(()=>60, []);
    const allRowsLength = allRowEdges ? allRowEdges.length : 0;
    const virtualizer = (0, $9suPc.useVirtualizer)({
        count: hasMoreData ? allRowsLength + 1 : allRowsLength,
        getScrollElement: ()=>parentRef.current,
        estimateSize: getRowHeight,
        overscan: 5
    });
    (0, $5uXOq.useEffect)(()=>{
        // save calling `getVirtualItems()` unnecessarily
        if (!allRowEdges || !hasMoreData) return;
        const lastItem = virtualizer.getVirtualItems().at(-1);
        if (lastItem && lastItem.index >= allRowEdges.length - 1) loadNext($6b7c2ece765359d1$var$PAZE_SIZE);
         // Do not change the dependency to just be `virtualizer` or `virtualizer.getVirtualItems`
    // it must call the function for dependencies to be calculated correctly (and therefore render at all).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allRowEdges,
        hasMoreData,
        loadNext,
        virtualizer.getVirtualItems()
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b7c2ece765359d1$var$LogsTableWrapper, {
        tabIndex: 0,
        ref: parentRef
    }, hasError === $6b7c2ece765359d1$var$NO_ERROR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        eventName: "LogsTableInTabsLayout Render"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ib5lJ.LogsTable), {
        virtualizer: virtualizer,
        allEdges: allRowEdges || [],
        projectKey: projectKey,
        outgoingMailConfigData: outgoingMailConfigData,
        selectedTab: selectedTab
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6b7c2ece765359d1$var$LogsTableWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3in9zg _1bsb1osq _1reo1wug _18m91wug _19pkpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ajbwj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa75551a827aac92$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5bd47a1191927ae0145b14c3c42ea5a0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $FXmIr = parcelRequire("FXmIr");
const $fa75551a827aac92$var$node = function() {
    var v0 = [
        "aquaOutgoingEmailLogs",
        "GetNotificationLogs",
        "logs"
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": 20,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "kind": "RootArgument",
                "name": "notificationActionType"
            },
            {
                "kind": "RootArgument",
                "name": "notificationType"
            },
            {
                "kind": "RootArgument",
                "name": "projectId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "count",
                        "cursor": "cursor"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $FXmIr.default)
            }
        },
        "name": "notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "concreteType": "AquaOutgoingEmailLogsQueryApi",
                "kind": "LinkedField",
                "name": "aquaOutgoingEmailLogs",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "notificationActionType",
                                "variableName": "notificationActionType"
                            },
                            {
                                "kind": "Variable",
                                "name": "notificationType",
                                "variableName": "notificationType"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectId",
                                "variableName": "projectId"
                            }
                        ],
                        "kind": "LinkedField",
                        "name": "GetNotificationLogs",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "alias": "logs",
                                        "concreteType": "AquaOutgoingEmailLogConnection",
                                        "kind": "LinkedField",
                                        "name": "__aquaOutgoingEmail__logs_connection",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "AquaOutgoingEmailLogItemEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "logsTableOfTabs_logEdges"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "cursor"
                                                    },
                                                    {
                                                        "concreteType": "AquaOutgoingEmailLogItem",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v1 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "startCursor"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "endCursor"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasNextPage"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasPreviousPage"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "type": "AquaOutgoingEmailLog"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "identifier"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "message"
                                    }
                                ],
                                "type": "QueryError"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$fa75551a827aac92$var$node.hash = "ce3f76d0fe1ca275bccfadfeb21cb8d7";
var $fa75551a827aac92$export$2e2bcd8739ae039 = $fa75551a827aac92$var$node;

});
parcelRegister("FXmIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f54bbd6ecd65ea56$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e7dca039c9ced47eb2026a1e22e10ff7>>
 * @relayHash c3353f84d926e53d182a7ef45d21f851
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 42516e8cdc4d8b41051ddf86c34fff50012d3cbb140d58a0d9283f9d09cb2d94
const $f54bbd6ecd65ea56$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": 20,
            "kind": "LocalArgument",
            "name": "count"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cursor"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "notificationActionType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "notificationType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "aquaEmailLogsQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        },
                        {
                            "kind": "Variable",
                            "name": "cursor",
                            "variableName": "cursor"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "aquaEmailLogsQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "AquaOutgoingEmailLogsQueryApi",
                    "kind": "LinkedField",
                    "name": "aquaOutgoingEmailLogs",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "notificationActionType",
                                    "variableName": "notificationActionType"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "notificationType",
                                    "variableName": "notificationType"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectId",
                                    "variableName": "projectId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "GetNotificationLogs",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v2 /*: any*/ ,
                                            "concreteType": "AquaOutgoingEmailLogConnection",
                                            "kind": "LinkedField",
                                            "name": "logs",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AquaOutgoingEmailLogItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AquaOutgoingEmailLogItem",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AquaIssueContext",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueContext",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssue",
                                                                            "kind": "LinkedField",
                                                                            "name": "issue",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "key"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "webUrl"
                                                                                },
                                                                                v3 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "notificationActionType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "actionTimestamp"
                                                                },
                                                                {
                                                                    "concreteType": "AquaNotificationDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "notificationDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "errorKey"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mailboxMessage"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "recipient",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "email"
                                                                                }
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "name"
                                                                                }
                                                                            ],
                                                                            "type": "CustomerUser"
                                                                        },
                                                                        v3 /*: any*/ 
                                                                    ]
                                                                },
                                                                v1 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "startCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasPreviousPage"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v2 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "aquaOutgoingEmail__logs",
                                            "kind": "LinkedHandle",
                                            "name": "logs"
                                        }
                                    ],
                                    "type": "AquaOutgoingEmailLog"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "42516e8cdc4d8b41051ddf86c34fff50012d3cbb140d58a0d9283f9d09cb2d94",
            "metadata": {},
            "name": "aquaEmailLogsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f54bbd6ecd65ea56$var$node.hash = "ce3f76d0fe1ca275bccfadfeb21cb8d7";
var $f54bbd6ecd65ea56$export$2e2bcd8739ae039 = $f54bbd6ecd65ea56$var$node;

});


parcelRegister("ib5lJ", function(module, exports) {

$parcel$export(module.exports, "LogsTable", () => $ce633959119528e2$export$58be81f5c6860851);

var $igkYG = parcelRequire("igkYG");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3bDjY = parcelRequire("3bDjY");
var $btzsC = parcelRequire("btzsC");

var $koVbs = parcelRequire("koVbs");

var $cYlk7 = parcelRequire("cYlk7");

var $5oFIy = parcelRequire("5oFIy");

var $cauZ3 = parcelRequire("cauZ3");

var $5w5Gb = parcelRequire("5w5Gb");

var $kMMUQ = parcelRequire("kMMUQ");

var $luOGq = parcelRequire("luOGq");
const $ce633959119528e2$var$issueFailuresTab = 'ISSUE_NOTIFICATION';
const $ce633959119528e2$var$rowRenderer = (virtualRow, edgeData, formatMessage, projectKey, selectedTab, timeZone)=>{
    const virtualRowIndex = virtualRow.index;
    if (!edgeData[virtualRowIndex]) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableRow, {
        "data-index": virtualRowIndex,
        height: virtualRow.size,
        translateY: virtualRow.start,
        key: virtualRowIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellSmall, {
        selectedTab: selectedTab
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellSmall, {
        selectedTab: selectedTab
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellMedium, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).loadMoreLogs)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellLarge, {
        selectedTab: selectedTab
    }));
    const { node: node } = edgeData[virtualRowIndex];
    const getDetailsCell = (details, tabSelected)=>{
        let errorMessageComponent;
        if (details) errorMessageComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luOGq.ErrorMessage), {
            errorKey: details.errorKey,
            projectKey: projectKey,
            mailboxMessage: details.mailboxMessage,
            formatMessage: formatMessage,
            tabSelected: tabSelected
        });
        const TooltipComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$InlineDialog, {
                ...props,
                ref: ref
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$LogsDetails, {
            selectedTab: selectedTab
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            position: "bottom-start",
            component: TooltipComponent,
            content: errorMessageComponent
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                "data-testid": "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.span",
                "aria-label": "tooltip",
                ...tooltipProps
            }, errorMessageComponent)));
    };
    const getNotificationTypeCell = (notificationType)=>{
        if (!notificationType) return null;
        const notificationName = (0, $luOGq.getNotificationName)(notificationType, formatMessage);
        const TooltipComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$InlineDialog, {
                ...props,
                ref: ref
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$NotificationTypeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            position: "bottom-start",
            component: TooltipComponent,
            content: notificationName
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", tooltipProps, notificationName)));
    };
    const getCustomerNameCell = (customerName)=>{
        const TooltipComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$InlineDialog, {
                ...props,
                ref: ref
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$CustomerNameWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            position: "bottom-start",
            component: TooltipComponent,
            content: customerName
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", tooltipProps, customerName)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, edgeData.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableRow, {
        "data-index": virtualRowIndex,
        height: virtualRow.size,
        translateY: virtualRow.start,
        key: virtualRowIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellSmall, {
        selectedTab: selectedTab
    }, (0, $luOGq.getLogDateTime)(node?.actionTimestamp, timeZone)), selectedTab === $ce633959119528e2$var$issueFailuresTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellSmall, {
        selectedTab: selectedTab
    }, getNotificationTypeCell(node?.notificationActionType)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellMedium, {
        selectedTab: selectedTab
    }, getCustomerNameCell(node?.recipient?.email || node?.recipient?.name)), selectedTab === $ce633959119528e2$var$issueFailuresTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellSmaller, {
        selectedTab: selectedTab
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        target: "_blank",
        href: node?.issueContext?.issue?.webUrl || ''
    }, node?.issueContext?.issue?.key)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellLarge, {
        selectedTab: selectedTab
    }, getDetailsCell(node?.notificationDetails, selectedTab))));
};
const $ce633959119528e2$export$ca3b93602b516d4a = ({ selectedTab: selectedTab, children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("table", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmall, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).tableHeaderDateTime)), selectedTab === $ce633959119528e2$var$issueFailuresTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmall, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).tableHeaderNotificationName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellMedium, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).tableHeaderCustomerEmail)), selectedTab === $ce633959119528e2$var$issueFailuresTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmaller, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).ticketKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellLarge, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).tableHeaderErrorMessage)))), children);
};
const $ce633959119528e2$export$84fdb000f10c6779 = ({ data: data, virtualizer: virtualizer, projectKey: projectKey, outgoingMailConfigData: outgoingMailConfigData, selectedTab: selectedTab })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: { user: user } } = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $cYlk7.useCurrentUser)();
    const timeZone = typeof user.timeZone === 'string' ? user.timeZone : '';
    const { outgoingMailConfig: outgoingMailConfig, error: error, loading: loading } = outgoingMailConfigData; // when we don't have customer logs i.e 0 logs
    if (!data.length && !error && !loading && outgoingMailConfig !== null) {
        if (!outgoingMailConfig?.enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
            eventName: "LogsTableInTabsLayout RenderOutgoingMailConfigDisabledTextAndEmptyTable"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$export$ca3b93602b516d4a, {
            selectedTab: selectedTab
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5w5Gb.NoDataEnableOutgoingMailInfo), null)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
            eventName: "LogsTableInTabsLayout RenderEmptyTable"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$export$ca3b93602b516d4a, {
            selectedTab: selectedTab
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kMMUQ.NoRecords), null)));
    }
    if (data.length) // when we have customer logs show table of records
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        eventName: "LogsTableInTabsLayout RenderTableWithData"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$InfiniteScrollTable, {
        totalSize: virtualizer.getTotalSize(),
        "data-testid": "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.infinite-scroll-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$Thead, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmall, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).tableHeaderDateTime)), selectedTab === $ce633959119528e2$var$issueFailuresTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmall, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).tableHeaderNotificationName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellMedium, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).tableHeaderCustomerEmail)), selectedTab === $ce633959119528e2$var$issueFailuresTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmaller, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).ticketKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellLarge, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).tableHeaderErrorMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableBody, {
        "data-testid": "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-body"
    }, virtualizer.getVirtualItems().map((virtualRow)=>$ce633959119528e2$var$rowRenderer(virtualRow, data, formatMessage, projectKey, selectedTab, timeZone)))));
    return null;
};
const $ce633959119528e2$export$58be81f5c6860851 = ({ allEdges: allEdges, virtualizer: virtualizer, projectKey: projectKey, outgoingMailConfigData: outgoingMailConfigData, selectedTab: selectedTab })=>{
    const LogsDataFragment = (0, $igkYG.default);
    const data = (0, $8Uumt.useFragment)(LogsDataFragment, allEdges);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$export$84fdb000f10c6779, {
        data: data,
        virtualizer: virtualizer,
        projectKey: projectKey,
        outgoingMailConfigData: outgoingMailConfigData,
        selectedTab: selectedTab
    });
};
const $ce633959119528e2$var$issueFailureTab = 'ISSUE_NOTIFICATION'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$LogsDetails = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsb1ogm" : "_1bsbcv93",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$CustomerNameWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1bsb1ogy",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$NotificationTypeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1bsb1ogy",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableCellSmaller = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bah1y6m",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsb9by0" : "_1bsbka7h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableCellSmall = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bah1y6m",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbrq8m" : "_1bsbka7h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableCellMedium = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bah1y6m",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbka7h" : "_1bsb1x1l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableCellLarge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bah1y6m",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbxe31" : "_1bsb1ssb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$Thead = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "thead", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_154iidpf _kqsw1if8 _1pbyb4wl _bfhkvuon _syaz1aqp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableHeaderCellSmaller = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bah1y6m _kqsw1if8 _k48p4jg8",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsb9by0" : "_1bsbka7h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableHeaderCellSmall = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bah1y6m _kqsw1if8 _k48p4jg8",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbrq8m" : "_1bsbka7h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableHeaderCellMedium = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bah1y6m _kqsw1if8 _k48p4jg8",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbka7h" : "_1bsb1x1l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableHeaderCellLarge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bah1y6m _kqsw1if8 _k48p4jg8",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbxe31" : "_1bsb1ssb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { translateY: translateY, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`),
            "--_1eykf4m": (0, $lD23V.default)(`translateY(${__cmplp.translateY}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsb1osq _4t3i2nrh _t9ec1inw _19pku2gc _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "tbody", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1kw7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$InfiniteScrollTable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "table", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { totalSize: totalSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_r9fzc2": (0, $lD23V.default)(`${__cmplp.totalSize}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1651 _1bsb1osq _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$InlineDialog = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $btzsC.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7vuon _2rko1l7b _16qs1mxi _p12fnklw _vchh18uv _ca0q7vkz _u5f31tcg _n3td7vkz _19bv1tcg _1nmz1hna",
            __cmplp.className
        ])
    });
});

});
parcelRegister("igkYG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b27263127f0e5e4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dd7e5115c428abaa4873896e829445c2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4b27263127f0e5e4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "logsTableOfTabs_logEdges",
    "selections": [
        {
            "concreteType": "AquaOutgoingEmailLogItem",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AquaIssueContext",
                    "kind": "LinkedField",
                    "name": "issueContext",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "webUrl"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "notificationActionType"
                },
                {
                    "kind": "ScalarField",
                    "name": "actionTimestamp"
                },
                {
                    "concreteType": "AquaNotificationDetails",
                    "kind": "LinkedField",
                    "name": "notificationDetails",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "errorKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "mailboxMessage"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "recipient",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "email"
                                }
                            ],
                            "type": "AtlassianAccountUser"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ],
                            "type": "CustomerUser"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "AquaOutgoingEmailLogItemEdge"
};
$4b27263127f0e5e4$var$node.hash = "1f58a219fb28a24ee938089d6601c5a2";
var $4b27263127f0e5e4$export$2e2bcd8739ae039 = $4b27263127f0e5e4$var$node;

});

parcelRegister("cauZ3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3dc15c60c4cd538d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $3dc15c60c4cd538d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    renderingFailed: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.rendering-failed",
        "defaultMessage": "Internal error. {linkStart}Resend the invite{linkEnd} later."
    },
    requestTooLong: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.request-too-long",
        "defaultMessage": "Notification size is greater than 6 MB. Reduce the size of customer invite template."
    },
    emailValidationFailure: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-validation-failure",
        "defaultMessage": "Unable to validate recipient\u2019s email address. Check the format and invite again."
    },
    rfc1918LanIpRoutingFailure: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.rfc-1918-lan-ip-routing-failure",
        "defaultMessage": "Recipient\u2019s email address belongs to a private address space. Invite again using the correct email address."
    },
    suppressedMessage: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.suppressed-message",
        "defaultMessage": "Recipient\u2019s email address is on a suppression list. Resend invite from the {linkStart}Customers page{linkEnd}."
    },
    suppressedMessageForRequestNotifications: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.suppressed-message-for-request-notifications",
        "defaultMessage": "Recipient\u2019s email address is on a suppression list."
    },
    bounced: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.bounced",
        "defaultMessage": "Error from email provider"
    },
    emailNotificationLimitReached: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-notification-limit-reached",
        "defaultMessage": "Reached the email notifications limit for {siteUrl}."
    },
    defaultErrorMessage: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.default-error-message",
        "defaultMessage": "An unknown error occurred. Try again later."
    },
    defaultErrorMessageForRequestNotification: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.default-error-message-for-request-notification",
        "defaultMessage": "An unknown error occurred."
    },
    tableHeaderDateTime: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-header-date-time",
        "defaultMessage": "Date and time"
    },
    tableHeaderNotificationName: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-header-notification-name",
        "defaultMessage": "Notification name"
    },
    tableHeaderCustomerEmail: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-header-customer-email",
        "defaultMessage": "Recipient"
    },
    tableHeaderErrorMessage: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-header-error-message",
        "defaultMessage": "Details"
    },
    ticketKey: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.ticket-key",
        "defaultMessage": "Issue key"
    },
    customerInvited: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.customer-invited",
        "defaultMessage": "Customer invited"
    },
    requestCreated: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.request-created",
        "defaultMessage": "Request created"
    },
    publicCommentAdded: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.public-comment-added",
        "defaultMessage": "Public comment added"
    },
    publicCommentEdited: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.public-comment-edited",
        "defaultMessage": "Public comment edited"
    },
    requestResolved: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.request-resolved",
        "defaultMessage": "Request resolved"
    },
    requestReopened: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.request-reopened",
        "defaultMessage": "Request reopened"
    },
    participantAdded: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.participant-added",
        "defaultMessage": "Participant added"
    },
    organizationAdded: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.organization-added",
        "defaultMessage": "Organization added"
    },
    approvalRequired: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.approval-required",
        "defaultMessage": "Approval required"
    },
    customerVisibleStatusChanged: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.customer-visible-status-changed",
        "defaultMessage": "Customer-visible status changed"
    },
    customNotification: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.custom-notification",
        "defaultMessage": "Custom notification"
    },
    loadMoreLogs: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.load-more-logs",
        "defaultMessage": "Loading more logs..."
    }
});

});

parcelRegister("5w5Gb", function(module, exports) {

$parcel$export(module.exports, "NoDataEnableOutgoingMailInfo", () => $9860b096251afcf0$export$31d032be89b0df83);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7nnPp = parcelRequire("7nnPp");


var $8Q4sF = parcelRequire("8Q4sF");

var $2JXc1 = parcelRequire("2JXc1");

var $koVbs = parcelRequire("koVbs");

var $kiDgp = parcelRequire("kiDgp");
const $9860b096251afcf0$var$Bold = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, children);
const $9860b096251afcf0$export$31d032be89b0df83 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const siteUrl = window.location.hostname;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9860b096251afcf0$var$OutgoingMailErrorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9860b096251afcf0$var$OutgoingMailInfoWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2JXc1.default), {
        height: "222",
        width: "191",
        alt: "no failure logs"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9860b096251afcf0$var$OutgoingMailErrorText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7nnPp))), {
        size: "medium",
        label: "",
        primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
        message: formatMessage((0, $kiDgp.messages).configDisabledAndNoFailureLogs, {
            boldStart: '{boldStart}',
            boldEnd: '{boldEnd}',
            siteUrl: siteUrl
        }),
        componentsMapping: {
            bold: $9860b096251afcf0$var$Bold
        }
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9860b096251afcf0$var$OutgoingMailErrorContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3idgin",
            __cmplp.className
        ])
    });
});
const $9860b096251afcf0$var$OutgoingMailInfoWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s8utpp _18u0idpf _y3gn1h6o _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $9860b096251afcf0$var$OutgoingMailErrorText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4utpp _19bvidpf _1e0c1o8l _vr2wh2mm _1t1812x7 _1tnd12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kiDgp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c535b9b4b8efd498$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $c535b9b4b8efd498$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    configDisabledAndNoFailureLogs: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.no-data-enable-outgoing-mail-info.config-disabled-and-no-failure-logs",
        "defaultMessage": "No data available as {boldStart}Outgoing Mail{boldEnd} is disabled for {siteUrl}."
    }
});

});


parcelRegister("kMMUQ", function(module, exports) {

$parcel$export(module.exports, "NoRecords", () => $e514ea095591694f$export$cdb065a719ea8884);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3a3KV = parcelRequire("3a3KV");

var $koVbs = parcelRequire("koVbs");

var $6oCSI = parcelRequire("6oCSI");
const $e514ea095591694f$export$cdb065a719ea8884 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e514ea095591694f$var$AllGoodContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e514ea095591694f$var$AllGoodContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e514ea095591694f$var$imageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3a3KV.default), {
        height: "150",
        width: "139",
        alt: "no failure logs"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h5", null, formatMessage((0, $6oCSI.messages).configEnabledAndNoFailureLogsMainText))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e514ea095591694f$var$AllGoodContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3ibfng",
            __cmplp.className
        ])
    });
});
const $e514ea095591694f$var$AllGoodContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _13tb1ejb _1gtfidpf",
            __cmplp.className
        ])
    });
});
const $e514ea095591694f$var$imageContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'center'
});

});
parcelRegister("6oCSI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bf7e923ae07c269c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bf7e923ae07c269c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    configEnabledAndNoFailureLogsMainText: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.no-records.config-enabled-and-no-failure-logs-main-text",
        "defaultMessage": "All set! Customer notifications were delivered successfully for your project."
    }
});

});


parcelRegister("luOGq", function(module, exports) {

$parcel$export(module.exports, "getLogDateTime", () => $0ced444745e60ec9$export$fbe52a537db76a48);
$parcel$export(module.exports, "ErrorMessage", () => $0ced444745e60ec9$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "getNotificationName", () => $0ced444745e60ec9$export$dc44215dd42a02db);

var $5uXOq = parcelRequire("5uXOq");

var $7CMcV = parcelRequire("7CMcV");

var $fVnbM = parcelRequire("fVnbM");

var $8Q4sF = parcelRequire("8Q4sF");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cauZ3 = parcelRequire("cauZ3");
const $0ced444745e60ec9$var$issueFailuresTab = 'ISSUE_NOTIFICATION';
const $0ced444745e60ec9$export$fbe52a537db76a48 = (dateString, timeZone)=>{
    if (dateString) {
        const dateObj = (0, $7CMcV.default)(dateString, timeZone);
        const year = dateObj.getFullYear();
        const month = dateObj.toLocaleString('en-us', {
            month: 'short'
        });
        const day = dateObj.getDate();
        const hours = dateObj.getHours();
        const minutes = dateObj.getMinutes();
        // Format the output date string
        const outputDateString = `${month} ${day}, ${year} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        return outputDateString;
    }
    return dateString;
};
const $0ced444745e60ec9$var$FormattedErrorWithLinkButton = ({ href: href, errorMessage: errorMessage, onLinkButtonClicked: onLinkButtonClicked })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
        componentsMapping: {
            link: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    appearance: "link",
                    spacing: "none",
                    href: href,
                    target: "_blank",
                    onClick: onLinkButtonClicked
                }, props.children)
        },
        message: formatMessage(errorMessage, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        })
    });
};
const $0ced444745e60ec9$var$FormattedErrorText = ({ errorMessage: errorMessage })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage(errorMessage));
};
const $0ced444745e60ec9$export$300e9e75480e4710 = ({ mailboxMessage: mailboxMessage, formatMessage: formatMessage })=>{
    const bouncedMessage = `${formatMessage((0, $cauZ3.messages).bounced)}: ${mailboxMessage}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, bouncedMessage);
};
const $0ced444745e60ec9$export$915e9e7bd4f0f96d = ({ errorKey: errorKey, projectKey: projectKey, mailboxMessage: mailboxMessage, formatMessage: formatMessage, tabSelected: tabSelected })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onInternalErrorResendInviteClicked = (0, $5uXOq.useCallback)(()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'internalErrorResendInviteLink',
            action: 'clicked'
        }), 'internalErrorResendInvite'), [
        createAnalyticsEvent
    ]);
    const suppressedErrorGoToCustomersPageClicked = (0, $5uXOq.useCallback)(()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'suppressedErrorGoToCustomersPageLink',
            action: 'clicked'
        }), 'suppressedErrorGoToCustomersPage'), [
        createAnalyticsEvent
    ]);
    switch(errorKey && errorKey.toLowerCase()){
        case 'rendering_failed':
        case 'retrieve_configuration_failed':
        case 'retryable_am_failure':
        case 'unknown_failure':
            {
                const href = `/jira/servicedesk/projects/${projectKey}/customers`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorWithLinkButton, {
                    href: href,
                    errorMessage: (0, $cauZ3.messages).renderingFailed,
                    onLinkButtonClicked: onInternalErrorResendInviteClicked
                });
            }
        case 'request_too_long':
        case 'request_size_exceeded':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                errorMessage: (0, $cauZ3.messages).requestTooLong
            });
        case 'email_validation_failure':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                errorMessage: (0, $cauZ3.messages).emailValidationFailure
            });
        case 'rfc1918_lan_ip_routing_failure':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                errorMessage: (0, $cauZ3.messages).rfc1918LanIpRoutingFailure
            });
        case 'suppressed':
            {
                if (tabSelected === $0ced444745e60ec9$var$issueFailuresTab) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                    errorMessage: (0, $cauZ3.messages).suppressedMessageForRequestNotifications
                });
                const href = `/jira/servicedesk/projects/${projectKey}/customers`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorWithLinkButton, {
                    href: href,
                    errorMessage: (0, $cauZ3.messages).suppressedMessage,
                    onLinkButtonClicked: suppressedErrorGoToCustomersPageClicked
                });
            }
        case 'email_notification_limit_reached':
            {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                const siteUrl = window.location.hostname;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                    values: {
                        siteUrl: siteUrl
                    },
                    ...(0, $cauZ3.messages).emailNotificationLimitReached
                });
            }
        case 'bounced':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$export$300e9e75480e4710, {
                mailboxMessage: mailboxMessage,
                formatMessage: formatMessage
            });
        default:
            if (tabSelected === $0ced444745e60ec9$var$issueFailuresTab) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                errorMessage: (0, $cauZ3.messages).defaultErrorMessageForRequestNotification
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                errorMessage: (0, $cauZ3.messages).defaultErrorMessage
            });
    }
};
const $0ced444745e60ec9$export$dc44215dd42a02db = (notificationType, formatMessage)=>{
    switch(notificationType.toLowerCase()){
        case 'customer_invite':
            return formatMessage((0, $cauZ3.messages).customerInvited);
        case 'request_created':
            return formatMessage((0, $cauZ3.messages).requestCreated);
        case 'public_comment_added':
            return formatMessage((0, $cauZ3.messages).publicCommentAdded);
        case 'public_comment_edited':
            return formatMessage((0, $cauZ3.messages).publicCommentEdited);
        case 'request_resolved':
            return formatMessage((0, $cauZ3.messages).requestResolved);
        case 'request_reopened':
            return formatMessage((0, $cauZ3.messages).requestReopened);
        case 'participant_added':
            return formatMessage((0, $cauZ3.messages).participantAdded);
        case 'organisation_added':
            return formatMessage((0, $cauZ3.messages).organizationAdded);
        case 'approval_required':
            return formatMessage((0, $cauZ3.messages).approvalRequired);
        case 'customer_visible_status_changed':
            return formatMessage((0, $cauZ3.messages).customerVisibleStatusChanged);
        case 'custom_notification':
            return formatMessage((0, $cauZ3.messages).customNotification);
        default:
            return '';
    }
};

});









//# sourceMappingURL=async-servicedesk-notification-logs.b54a08fa.js.map
